import * as React from "react";
const AnniversaryWebsiteSVG = (props) => (
  <svg
    className="animated"
    id="freepik_stories-wedding-cake"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
 
    {...props}
  >
    <style>
      {
        "svg#freepik_stories-wedding-cake:not(.animated) .animable {opacity: 0;}svg#freepik_stories-wedding-cake.animated #freepik--background-complete--inject-78 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-wedding-cake.animated #freepik--Table--inject-78 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-wedding-cake.animated #freepik--Plant--inject-78 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-wedding-cake.animated #freepik--Cake--inject-78 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}            @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        "
      }
    </style>
    <g
      id="freepik--background-complete--inject-78"
      className="animable"
      style={{
        transformOrigin: "258.345px 256.215px",
      }}
    >
      <path
        d="M384.56,151.32a12.23,12.23,0,0,0-2.78-6.81,11.76,11.76,0,0,0-5.92-4.1,9.66,9.66,0,0,0-7.48,1.06,9.54,9.54,0,0,0-3.21,3.26,9.57,9.57,0,0,0-2.66-3.2,9.68,9.68,0,0,0-7.33-1.86,11.76,11.76,0,0,0-6.33,3.44,12.27,12.27,0,0,0-3.49,6.47,14.89,14.89,0,0,0,1.36,9.25A21.12,21.12,0,0,0,353.6,166c4.59,3.11,10.63,7,10.63,7s5.49-3.66,10.38-6.26a20.91,20.91,0,0,0,7.61-6.4A14.86,14.86,0,0,0,384.56,151.32Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "364.864px 156.279px",
        }}
        id="elr1jgxf3i84"
        className="animable"
      />
      <path
        d="M140,221.78a18.79,18.79,0,0,0-8.76-7.19,18.11,18.11,0,0,0-11-1.22,14.67,14.67,0,0,0-11.35,13.71,14.67,14.67,0,0,0-6-2.4,14.92,14.92,0,0,0-11.31,2.87,18.12,18.12,0,0,0-6,9.31,18.83,18.83,0,0,0,0,11.34,22.92,22.92,0,0,0,8.63,11.55c4.23,2.82,9.55,4.18,14.61,4.69,8.5.85,19.57,1.72,19.57,1.72s4.75-9,9.48-16.11c2.81-4.23,5.13-9.22,5.63-14.27A23,23,0,0,0,140,221.78Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "114.135px 239.584px",
        }}
        id="el0mugfd389un9"
        className="animable"
      />
      <path
        d="M120.93,177.83a7.23,7.23,0,0,0-2.94-3.16,6.88,6.88,0,0,0-4.09-1,5.63,5.63,0,0,0-3.89,2.13,5.74,5.74,0,0,0-1.08,2.46,5.55,5.55,0,0,0-6.53-.7,6.93,6.93,0,0,0-2.75,3.2,7.23,7.23,0,0,0-.57,4.27,8.76,8.76,0,0,0,2.67,4.79,12.41,12.41,0,0,0,5.26,2.51c3.16.75,7.29,1.63,7.29,1.63s2.24-3.14,4.38-5.58a12.32,12.32,0,0,0,2.85-5.09A8.75,8.75,0,0,0,120.93,177.83Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "110.349px 183.806px",
        }}
        id="elgcw9cdzsqw"
        className="animable"
      />
      <path
        d="M98.31,291.73a6.15,6.15,0,0,0-1.91-3.15A5.88,5.88,0,0,0,93.15,287a4.77,4.77,0,0,0-5,3,4.73,4.73,0,0,0-5.33-1.72,5.82,5.82,0,0,0-2.86,2.2,6.12,6.12,0,0,0-1.23,3.47,7.46,7.46,0,0,0,1.4,4.47,10.57,10.57,0,0,0,4,3c2.51,1.18,5.81,2.64,5.81,2.64s2.43-2.24,4.65-3.91a10.65,10.65,0,0,0,3.26-3.77A7.45,7.45,0,0,0,98.31,291.73Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "88.6096px 295.514px",
        }}
        id="elime3is1w0wq"
        className="animable"
      />
      <path
        d="M353.8,117.76a6.27,6.27,0,0,0-.85-3.65,6,6,0,0,0-2.64-2.54,4.83,4.83,0,0,0-5.73,1.3,5,5,0,0,0-1.07-1.83,4.9,4.9,0,0,0-3.54-1.52,6,6,0,0,0-3.46,1.21,6.2,6.2,0,0,0-2.28,3,7.6,7.6,0,0,0-.07,4.76,10.73,10.73,0,0,0,2.88,4.17c2,1.94,4.77,4.39,4.77,4.39s3.05-1.39,5.72-2.3a10.73,10.73,0,0,0,4.35-2.6A7.61,7.61,0,0,0,353.8,117.76Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "343.815px 118.285px",
        }}
        id="elbl4t29cr1ge"
        className="animable"
      />
      <path
        d="M167.67,139.91a12.79,12.79,0,0,0-4.09-6.5,12.34,12.34,0,0,0-6.84-3.14,10.1,10.1,0,0,0-7.51,2.44,10,10,0,0,0-2.71,3.94,9.92,9.92,0,0,0-11.19-3.4,12.31,12.31,0,0,0-5.89,4.68,12.77,12.77,0,0,0-2.42,7.3,15.51,15.51,0,0,0,3.07,9.27,22,22,0,0,0,8.38,6.14c5.28,2.37,12.21,5.3,12.21,5.3s5-4.76,9.54-8.32a22,22,0,0,0,6.68-8A15.55,15.55,0,0,0,167.67,139.91Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "147.567px 148.086px",
        }}
        id="el0hqr3osol02s"
        className="animable"
      />
      <path
        d="M427,315.74a9.52,9.52,0,0,0-1.11-5.62,9.11,9.11,0,0,0-3.9-4,7.38,7.38,0,0,0-8.82,1.69,7.41,7.41,0,0,0-6.88-5.36,9.17,9.17,0,0,0-5.34,1.68,9.52,9.52,0,0,0-3.64,4.42,11.61,11.61,0,0,0-.35,7.27,16.3,16.3,0,0,0,4.19,6.52c3,3.06,7.06,6.95,7.06,6.95s4.74-2,8.87-3.22a16.58,16.58,0,0,0,6.78-3.75A11.62,11.62,0,0,0,427,315.74Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "411.798px 315.87px",
        }}
        id="elpqh5fqphqi"
        className="animable"
      />
      <ellipse
        cx={247.01}
        cy={455.61}
        rx={142.31}
        ry={21.23}
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "247.01px 455.61px",
        }}
        id="el9obcxhuldz6"
        className="animable"
      />
      <path
        d="M180.28,42.15l4.62,1.74-4,1.14a4.19,4.19,0,0,0-2.84,2.72l-1.45,4.44-1.79-4.45a4.17,4.17,0,0,0-2.45-2.38l-4.06-1.47,4.4-1.81A4.16,4.16,0,0,0,175,39.72l1.59-4.13,1.14,3.84A4.17,4.17,0,0,0,180.28,42.15Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "176.605px 43.89px",
        }}
        id="el2cqb8boep8u"
        className="animable"
      />
      <path
        d="M372.35,71.63l1.64.61-1.42.41a1.47,1.47,0,0,0-1,1l-.51,1.57-.63-1.57a1.47,1.47,0,0,0-.87-.84l-1.43-.53,1.55-.63a1.5,1.5,0,0,0,.82-.84l.56-1.46.4,1.36A1.51,1.51,0,0,0,372.35,71.63Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "371.06px 72.285px",
        }}
        id="ele8h7xxp7rg"
        className="animable"
      />
      <path
        d="M418,287.15l3,1.12-2.59.73a2.73,2.73,0,0,0-1.83,1.76l-.94,2.86-1.15-2.87a2.68,2.68,0,0,0-1.58-1.53l-2.62-1,2.84-1.17a2.71,2.71,0,0,0,1.49-1.52l1-2.67.74,2.48A2.71,2.71,0,0,0,418,287.15Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "415.645px 288.24px",
        }}
        id="elhyomon90w08"
        className="animable"
      />
      <path
        d="M71.06,178.13l3,1.12-2.59.73a2.7,2.7,0,0,0-1.82,1.76l-.94,2.86-1.15-2.87A2.72,2.72,0,0,0,66,180.2l-2.62-.95,2.84-1.17a2.65,2.65,0,0,0,1.49-1.52l1-2.67.73,2.48A2.71,2.71,0,0,0,71.06,178.13Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "68.72px 179.245px",
        }}
        id="el8sxwwt7ccog"
        className="animable"
      />
      <path
        d="M446.26,270l7.05,2.65-6.12,1.74a6.35,6.35,0,0,0-4.32,4.15l-2.22,6.77-2.72-6.79a6.39,6.39,0,0,0-3.74-3.62L428,272.69l6.7-2.76a6.37,6.37,0,0,0,3.53-3.6l2.42-6.3,1.74,5.85A6.37,6.37,0,0,0,446.26,270Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "440.655px 272.67px",
        }}
        id="elpx3qqmc4pa"
        className="animable"
      />
      <path
        d="M90.3,145.43l7,2.65-6.12,1.74A6.39,6.39,0,0,0,86.9,154l-2.21,6.77L82,154a6.4,6.4,0,0,0-3.75-3.62L72,148.08l6.71-2.75a6.39,6.39,0,0,0,3.53-3.61l2.42-6.3,1.74,5.86A6.38,6.38,0,0,0,90.3,145.43Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "84.65px 148.095px",
        }}
        id="elbyig9a5v2nj"
        className="animable"
      />
      <path
        d="M357.79,80.64l5,1.87-4.33,1.23a4.46,4.46,0,0,0-3.05,2.93l-1.57,4.78-1.92-4.79a4.53,4.53,0,0,0-2.64-2.56l-4.38-1.59,4.74-2A4.46,4.46,0,0,0,352.11,78l1.71-4.44,1.23,4.13A4.51,4.51,0,0,0,357.79,80.64Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "353.845px 82.505px",
        }}
        id="elr6qeodg0ai8"
        className="animable"
      />
    </g>
    <g
      id="freepik--Table--inject-78"
      className="animable"
      style={{
        transformOrigin: "250px 357.06px",
      }}
    >
      <path
        d="M482.16,357.06c0,.14-104,.26-232.15.26s-232.17-.12-232.17-.26,103.93-.26,232.17-.26S482.16,356.92,482.16,357.06Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "250px 357.06px",
        }}
        id="elilq361w008j"
        className="animable"
      />
    </g>
    <g
      id="freepik--Plant--inject-78"
      className="animable"
      style={{
        transformOrigin: "248.6px 297.968px",
      }}
    >
      <path
        d="M444.11,236C407.83,228.3,379.5,247,379.5,247,407.71,260.68,444.11,236,444.11,236Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "411.805px 242.636px",
        }}
        id="elfx6197zgg4m"
        className="animable"
      />
      <path
        d="M341,234.18c0,22.76,15.27,38.51,15.27,38.51C361,254.34,341,234.18,341,234.18Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "348.997px 253.435px",
        }}
        id="elb7805b6nk45"
        className="animable"
      />
      <path
        d="M364.87,270.28c26.82,5.26,48.9-9,48.9-9C393.26,251.45,364.87,270.28,364.87,270.28Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "389.32px 264.942px",
        }}
        id="elwbu2s6jaj7"
        className="animable"
      />
      <path
        d="M394.55,223.21c-.41-.29-12.11,15.66-26.11,35.63s-25,36.39-24.61,36.68,12.1-15.65,26.11-35.63S395,223.5,394.55,223.21Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "369.192px 259.365px",
        }}
        id="eldindwocq2ye"
        className="animable"
      />
      <path
        d="M434.47,180s-39.9,14.07-45,51.52C389.49,231.47,423.69,219.93,434.47,180Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "411.97px 205.76px",
        }}
        id="elnsw9dtww1p"
        className="animable"
      />
      <path
        d="M374.41,184.3s-23.64,35.08-5.4,68.18C369,252.48,389.6,222.83,374.41,184.3Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "371.048px 218.39px",
        }}
        id="elt4716jso3ij"
        className="animable"
      />
      <path
        d="M100.23,325.54c-10.22,27.75,1.27,52.23,1.27,52.23C115.55,357.07,100.23,325.54,100.23,325.54Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "101.713px 351.655px",
        }}
        id="elodbzkx7ag6"
        className="animable"
      />
      <path
        d="M88.63,411.2c18,2.6,32.13-7.66,32.13-7.66C106.83,397.66,88.63,411.2,88.63,411.2Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "104.695px 406.841px",
        }}
        id="elz411sepv9nq"
        className="animable"
      />
      <path
        d="M119.85,396.45c7.21-20.57-1.51-39.62-1.51-39.62C108.23,371.9,119.85,396.45,119.85,396.45Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "118.456px 376.64px",
        }}
        id="eliw4fx4q7x0a"
        className="animable"
      />
      <path
        d="M86.09,367.65c-.27.3,11,11.35,25.14,24.67s25.86,23.91,26.14,23.61-11-11.34-25.14-24.67S86.37,367.36,86.09,367.65Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "111.73px 391.79px",
        }}
        id="el4nd9x6qz9v5"
        className="animable"
      />
      <path
        d="M56.51,331.22S63.06,364.31,92,372.59C92,372.59,86.83,344.29,56.51,331.22Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "74.255px 351.905px",
        }}
        id="el0erhb544z6ct"
        className="animable"
      />
      <path
        d="M53.09,379.11s25,22.66,53.18,12C106.27,391.15,85.22,371.52,53.09,379.11Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "79.68px 385.663px",
        }}
        id="elfp61s5615n"
        className="animable"
      />
    </g>
    <g
      id="freepik--Cake--inject-78"
      className="animable animator-active"
      style={{
        transformOrigin: "248.69px 252.843px",
      }}
    >
      <ellipse
        cx={248.69}
        cy={434.3}
        rx={153.46}
        ry={34.67}
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "248.69px 434.3px",
        }}
        id="el81h9lu2uwox"
        className="animable"
      />
      <path
        d="M100.64,429.92a8.75,8.75,0,0,0,.69,3.1c.77,1.94,2.76,4.44,6,6.76,6.48,4.69,17.42,8.9,31.23,12.35,27.7,6.93,67.16,11.1,110.7,11.11s83-4.18,110.72-11.11c13.82-3.45,24.75-7.66,31.23-12.35,3.24-2.32,5.22-4.82,6-6.76a9.37,9.37,0,0,0,.69-3.1s0,.27,0,.81a8.42,8.42,0,0,1-.58,2.33c-.75,2-2.73,4.53-6,6.89-6.49,4.76-17.43,9-31.26,12.54-27.72,7-67.22,11.26-110.81,11.27s-83.06-4.24-110.79-11.27C124.64,449,113.7,444.71,107.21,440c-3.24-2.36-5.23-4.91-6-6.89a8.33,8.33,0,0,1-.57-2.33C100.64,430.19,100.64,429.92,100.64,429.92Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "249.27px 446.84px",
        }}
        id="elcyyye5galzk"
        className="animable"
      />
      <rect
        x={124.41}
        y={300.51}
        width={250.23}
        height={133.79}
        style={{
          fill: "#213E60",
          transformOrigin: "249.525px 367.405px",
        }}
        id="elo6c1jyhyiw"
        className="animable"
      />
      <ellipse
        cx={249.85}
        cy={434.37}
        rx={125.12}
        ry={21.64}
        style={{
          fill: "#213E60",
          transformOrigin: "249.85px 434.37px",
        }}
        id="eld7hnkjsjtnh"
        className="animable"
      />
      <g id="el4z2xxogsl1d">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "247.84px 364.16px",
          }}
          className="animable"
          id="eltcqbfntew6q"
        >
          <path
            d="M373.3,341.59c-1.34,7.77-2.87,16-8.15,22s-15.63,8.73-21.76,3.49c-5.35-4.58-6.46-13.87-13.44-15.42-6-1.33-11.05,4.48-13.54,9.9s-4.78,11.85-10.54,14c-7.42,2.73-15.46-3.57-23.32-2.48-5.93.81-10.27,5.54-14.73,9.39s-10.82,7.16-16.2,4.62c-6.43-3.05-8-13.05-15.09-14-7.55-1-14.1,9.76-20.85,6.39-5.75-2.86-4.63-13.55-11.05-14.31-5-.6-7.26,5.81-10.9,9.22a11.2,11.2,0,0,1-13.68.83c-2.41-1.74-4.22-4.57-7.19-5.09-4.6-.79-7.76,4.42-8.53,8.84s-1.07,9.66-5,12.11c-3.57,2.24-8.62.75-11.56-2.22s-4.25-7.05-5.49-11l-6.42-20.39c-3.72,3.66-11.16,2.5-13.48-2.11l1.74-19.2Z"
            id="elg8gpc6ils15"
            className="animable"
            style={{
              transformOrigin: "247.84px 364.16px",
            }}
          />
        </g>
      </g>
      <path
        d="M380.62,293.75a22.74,22.74,0,0,0-5.73-6.15C365.59,275.73,314,270,252.35,270c-45.79,0-85.34,3.59-103.89,8.78-11,2.34-21,8.53-26.91,17.1-4.92,7.18-7,15.66-7.35,24s.86,16.75,2.08,25.07c.45,3,.94,6.13,2.9,8.62s5.84,4.08,8.93,2.74c2.07-.9,3.24-2.83,4.64-4.45s3.58-3.13,5.82-2.62c2.46.57,3.42,3.14,3.93,5.34A183.91,183.91,0,0,1,146.57,380c.22,2.52.41,5.12,1.64,7.41a7.06,7.06,0,0,0,12.81.09,19.75,19.75,0,0,0,1.81-6.9,110.77,110.77,0,0,1,2.43-11.94,13.84,13.84,0,0,1,2.49-5.61,6.52,6.52,0,0,1,5.94-2.34c6.11,1.16,4.78,11,10.77,12.59a7,7,0,0,0,6.17-1.73,16.56,16.56,0,0,0,3.51-5.09c2.28-4.41,6.54-19.69,15-13.16,2.57,2,3.5,5.1,4.12,8.06s1.11,6.07,3.14,8.49,6.23,3.73,8.94,1.9c2.2-1.48,2.73-4.5,5.2-5.63,2.31-1.06,5.28.17,6.78,2s2,4.23,2.58,6.46c1.37,4.91,3.89,9.79,8.39,12.94s11.3,4.09,16,1.22c3.78-2.29,5.52-6.38,6.61-10.3s1.83-8.05,4.38-11.41,7.64-5.66,11.79-3.95,5.44,6.25,9.1,8.5c4.7,2.89,11.49.87,15.48-2.74s6.16-8.46,9.23-12.72,7.78-8.25,13.51-8.29c6.72-.05,11.78,5.18,15.56,10.07s8.06,10.38,14.67,11.39,13.19-3.25,16.21-8.57,3.33-11.48,3.58-17.42q.45-10.53.89-21.07C385.79,312.53,386.05,302.24,380.62,293.75Z"
        style={{
          fill: "#213E60",
          transformOrigin: "249.839px 330.773px",
        }}
        id="el68yckybj0ai"
        className="animable"
      />
      <g id="elow5ceqsryi">
        <path
          d="M380.62,293.75a22.74,22.74,0,0,0-5.73-6.15C365.59,275.73,314,270,252.35,270c-45.79,0-85.34,3.59-103.89,8.78-11,2.34-21,8.53-26.91,17.1-4.92,7.18-7,15.66-7.35,24s.86,16.75,2.08,25.07c.45,3,.94,6.13,2.9,8.62s5.84,4.08,8.93,2.74c2.07-.9,3.24-2.83,4.64-4.45s3.58-3.13,5.82-2.62c2.46.57,3.42,3.14,3.93,5.34A183.91,183.91,0,0,1,146.57,380c.22,2.52.41,5.12,1.64,7.41a7.06,7.06,0,0,0,12.81.09,19.75,19.75,0,0,0,1.81-6.9,110.77,110.77,0,0,1,2.43-11.94,13.84,13.84,0,0,1,2.49-5.61,6.52,6.52,0,0,1,5.94-2.34c6.11,1.16,4.78,11,10.77,12.59a7,7,0,0,0,6.17-1.73,16.56,16.56,0,0,0,3.51-5.09c2.28-4.41,6.54-19.69,15-13.16,2.57,2,3.5,5.1,4.12,8.06s1.11,6.07,3.14,8.49,6.23,3.73,8.94,1.9c2.2-1.48,2.73-4.5,5.2-5.63,2.31-1.06,5.28.17,6.78,2s2,4.23,2.58,6.46c1.37,4.91,3.89,9.79,8.39,12.94s11.3,4.09,16,1.22c3.78-2.29,5.52-6.38,6.61-10.3s1.83-8.05,4.38-11.41,7.64-5.66,11.79-3.95,5.44,6.25,9.1,8.5c4.7,2.89,11.49.87,15.48-2.74s6.16-8.46,9.23-12.72,7.78-8.25,13.51-8.29c6.72-.05,11.78,5.18,15.56,10.07s8.06,10.38,14.67,11.39,13.19-3.25,16.21-8.57,3.33-11.48,3.58-17.42q.45-10.53.89-21.07C385.79,312.53,386.05,302.24,380.62,293.75Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.6,
            transformOrigin: "249.839px 330.773px",
          }}
          className="animable"
          id="elrrw2d7os67e"
        />
      </g>
      <g id="el0p5ype4zj9ed">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "247.975px 429.692px",
          }}
          className="animable"
          id="elvrp9km8kvxe"
        >
          <path
            d="M123.8,418.42c16,14.5,38.76,18.19,60.23,20.26a654.29,654.29,0,0,0,153.2-2.86c6.8-.95,13.68-2,20-4.76s12.08-7.28,14.92-13.54Z"
            id="elz03ddhv1b4j"
            className="animable"
            style={{
              transformOrigin: "247.975px 429.692px",
            }}
          />
        </g>
      </g>
      <path
        d="M375,415.13c0,12-56,21.65-125.12,21.65s-125.11-9.69-125.11-21.65V396.27c0,12,56,21.65,125.11,21.65S375,408.23,375,396.27Z"
        style={{
          fill: "#213E60",
          transformOrigin: "249.885px 416.525px",
        }}
        id="elrslcfuhagbg"
        className="animable"
      />
      <g id="elsw29h6c4av9">
        <path
          d="M375,415.13c0,12-56,21.65-125.12,21.65s-125.11-9.69-125.11-21.65V396.27c0,12,56,21.65,125.11,21.65S375,408.23,375,396.27Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.4,
            transformOrigin: "249.885px 416.525px",
          }}
          className="animable"
          id="elypu93aq1hl"
        />
      </g>
      <g id="el4q94p38qiy7">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "147.844px 439.265px",
          }}
          className="animable"
          id="elsaesevyaape"
        >
          <path
            d="M151.09,437.86c-.57-1.63-2.8-2-4.47-1.57a2.72,2.72,0,0,0-2,1.64,3.17,3.17,0,0,0,.14,2.64,3.47,3.47,0,0,0,6.36-2.71Z"
            id="elp5a55dqh8e"
            className="animable"
            style={{
              transformOrigin: "147.844px 439.265px",
            }}
          />
        </g>
      </g>
      <g id="el11hcaxoyu5mk">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "330.106px 442.404px",
          }}
          className="animable"
          id="elnzs1brcv4za"
        >
          <path
            d="M333.35,441c-.56-1.64-2.8-2-4.47-1.57a2.72,2.72,0,0,0-2,1.64,3.21,3.21,0,0,0,.14,2.64,3.47,3.47,0,0,0,6.36-2.71Z"
            id="elksd2bzz7uf"
            className="animable"
            style={{
              transformOrigin: "330.106px 442.404px",
            }}
          />
        </g>
      </g>
      <g id="elpcteiknlshk">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "283.394px 412.099px",
          }}
          className="animable"
          id="elwiqiehox9s"
        >
          <path
            d="M287.34,411c-.68-1.28-3.37-1.59-5.38-1.23a3.34,3.34,0,0,0-2.45,1.28,1.74,1.74,0,0,0,.17,2.06c.95,1.21,3.43,1.79,5.35,1.26S288,412.27,287.34,411Z"
            id="elm4m26dzf3h"
            className="animable"
            style={{
              transformOrigin: "283.394px 412.099px",
            }}
          />
        </g>
      </g>
      <g id="elpi7dad874k9">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "225.958px 409.612px",
          }}
          className="animable"
          id="el8vqdnhc1ptx"
        >
          <path
            d="M223.31,406.18c-1.77,1.19-1.53,3.91-.46,5.71a3.3,3.3,0,0,0,2.59,1.82,4,4,0,0,0,3.1-1,4.29,4.29,0,0,0,.52-5.69A4.47,4.47,0,0,0,223.31,406.18Z"
            id="elpirei32c04a"
            className="animable"
            style={{
              transformOrigin: "225.958px 409.612px",
            }}
          />
        </g>
      </g>
      <g id="elftpz9l6y5s">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "334.978px 402.485px",
          }}
          className="animable"
          id="elinyhoxssqt"
        >
          <path
            d="M336.61,401.79c-.29-.82-1.4-1-2.24-.79a1.34,1.34,0,0,0-1,.82,1.6,1.6,0,0,0,.06,1.32,1.74,1.74,0,0,0,3.19-1.35Z"
            id="el9zocuny5qve"
            className="animable"
            style={{
              transformOrigin: "334.978px 402.485px",
            }}
          />
        </g>
      </g>
      <g id="elumhwjczaqrn">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "265.579px 410.653px",
          }}
          className="animable"
          id="elejd06n9o2hp"
        >
          <path
            d="M267.2,409.93c-.29-.82-1.4-1-2.24-.79a1.34,1.34,0,0,0-1,.82,1.56,1.56,0,0,0,.07,1.32,1.73,1.73,0,0,0,3.18-1.35Z"
            id="ele9o6ufttju"
            className="animable"
            style={{
              transformOrigin: "265.579px 410.653px",
            }}
          />
        </g>
      </g>
      <g id="elysqf7rxt74k">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "209.933px 447.195px",
          }}
          className="animable"
          id="elsmywmngchb"
        >
          <path
            d="M211.54,446.47c-.28-.82-1.39-1-2.23-.78a1.37,1.37,0,0,0-1,.82,1.62,1.62,0,0,0,.07,1.31,1.73,1.73,0,0,0,3.18-1.35Z"
            id="eldv3iqefvduw"
            className="animable"
            style={{
              transformOrigin: "209.933px 447.195px",
            }}
          />
        </g>
      </g>
      <g id="el5ja91fm8hve">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "174.903px 404.893px",
          }}
          className="animable"
          id="elkfzk28pyqu"
        >
          <path
            d="M176.51,404.17c-.28-.82-1.4-1-2.23-.79a1.37,1.37,0,0,0-1,.82,1.64,1.64,0,0,0,.07,1.32,1.73,1.73,0,0,0,3.18-1.35Z"
            id="el9rz7hvfymy4"
            className="animable"
            style={{
              transformOrigin: "174.903px 404.893px",
            }}
          />
        </g>
      </g>
      <g id="elokkbcortgw">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "272.174px 407.98px",
          }}
          className="animable"
          id="elawy9luucuwa"
        >
          <path
            d="M273,407.63c-.14-.41-.7-.51-1.11-.39a.67.67,0,0,0-.51.41.8.8,0,0,0,0,.66.91.91,0,0,0,1.11.4A.89.89,0,0,0,273,407.63Z"
            id="elauqzp6wurc"
            className="animable"
            style={{
              transformOrigin: "272.174px 407.98px",
            }}
          />
        </g>
      </g>
      <g id="elxewnj8ixud">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "237.355px 412.355px",
          }}
          className="animable"
          id="eloh0e36lqp3o"
        >
          <path
            d="M238.19,412c-.15-.41-.7-.5-1.12-.39a.69.69,0,0,0-.51.41.77.77,0,0,0,0,.66.89.89,0,0,0,1.11.4A.9.9,0,0,0,238.19,412Z"
            id="elmal6tcfndtq"
            className="animable"
            style={{
              transformOrigin: "237.355px 412.355px",
            }}
          />
        </g>
      </g>
      <g id="elknoy94z8g2">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "359.098px 438.474px",
          }}
          className="animable"
          id="elsgmh5la36wk"
        >
          <path
            d="M359.94,438.13c-.14-.41-.7-.5-1.12-.39a.65.65,0,0,0-.5.41.8.8,0,0,0,0,.66.87.87,0,0,0,1.59-.68Z"
            id="el4f1eoq5e3lc"
            className="animable"
            style={{
              transformOrigin: "359.098px 438.474px",
            }}
          />
        </g>
      </g>
      <g id="el7pbiigc9yvs">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "280.509px 447.085px",
          }}
          className="animable"
          id="elwjnrr1zom8h"
        >
          <path
            d="M281.36,446.74c-.14-.4-.7-.5-1.12-.39a.69.69,0,0,0-.51.41.8.8,0,0,0,0,.66.87.87,0,0,0,1.59-.68Z"
            id="elr11hi5xfyls"
            className="animable"
            style={{
              transformOrigin: "280.509px 447.085px",
            }}
          />
        </g>
      </g>
      <g id="elyt97bjeow8s">
        <g
          style={{
            opacity: 0.4,
            transformOrigin: "241.674px 331.825px",
          }}
          className="animable"
          id="el4am9g7rt3zi"
        >
          <ellipse
            cx={250.31}
            cy={293.17}
            rx={115.85}
            ry={16.65}
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "250.31px 293.17px",
            }}
            id="ely4rc9lg4qvh"
            className="animable"
          />
          <path
            d="M270.11,315.58c0,.18-1.7.39-4.78.63s-7.55.46-13.08.62c-11.05.3-26.34.32-43.19-.77a365.52,365.52,0,0,1-42.93-5.1l-3.88-.73-3.44-.74c-2.15-.46-4-.88-5.49-1.29-3-.78-4.63-1.29-4.59-1.47.08-.39,6.79.86,17.7,2.41s26,3.27,42.79,4.32,32,1.36,43,1.53S270.09,315.2,270.11,315.58Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "209.42px 311.832px",
            }}
            id="el8qkvvkhet9d"
            className="animable"
          />
          <path
            d="M299.34,314.31c0,.72-4.17,1.5-9.38,1.75s-9.47-.14-9.51-.86,4.17-1.5,9.39-1.74S299.31,313.6,299.34,314.31Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "289.895px 314.762px",
            }}
            id="eltgkow8q6hw"
            className="animable"
          />
          <path
            d="M117.36,327.3c-.6,7.43.31,15.69,3.71,22.59.7,1.43,3.33,2.69,5.2,2.61,1.56-.06,2.6-1.31,3.3-2.47a25.65,25.65,0,0,0,2.31-5c.47-1.42.61-3.27-.92-4a13.55,13.55,0,0,0-3-.52c-2.11-.46-3.2-2.34-4-4l-4.11-8.38a2.39,2.39,0,0,0-1-1.22c-.53-.26-1.39-.07-1.46.43"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "124.694px 339.649px",
            }}
            id="el78so6p7icyp"
            className="animable"
          />
          <path
            d="M263.12,383.31c-.42-1.34-2.26-2-3.93-2.15a30.67,30.67,0,0,1-5-.31A7.53,7.53,0,0,1,250,378a24.48,24.48,0,0,1-2.28-4.16,6,6,0,0,0-2.18-2.76l0,0c-1.68-1-3.88.58-3.08,2.15a37.23,37.23,0,0,0,7.11,9.56,15.59,15.59,0,0,0,5.31,3.73,8,8,0,0,0,6.69-.26A2.75,2.75,0,0,0,263.12,383.31Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "252.724px 378.948px",
            }}
            id="elooa12z47fdk"
            className="animable"
          />
          <path
            d="M268.21,373.89A2.81,2.81,0,0,0,266,372.8a3.64,3.64,0,0,0-3.32,1.93,3.32,3.32,0,0,0,.17,3.46,3,3,0,0,0,1.74,1.26,3.31,3.31,0,0,0,3.08-.9,3.94,3.94,0,0,0,1-2.7A3.2,3.2,0,0,0,268.21,373.89Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "265.478px 376.165px",
            }}
            id="elhifjp1di5s8"
            className="animable"
          />
        </g>
      </g>
      <g id="elqu8xh6uoc8">
        <path
          d="M299.34,300.3s34.59-2.82,43.64-7.46,13.18-14.12,13.18-14.12-7.89-2.44-22.18-4.09C328.24,274,299.34,300.3,299.34,300.3Z"
          style={{
            opacity: 0.2,
            transformOrigin: "327.75px 287.459px",
          }}
          className="animable"
          id="elympf5ou2pvi"
        />
      </g>
      <path
        d="M241.81,465.06a3.34,3.34,0,0,0-1.37-.25l-15.54-.66c-1.43-.13-2.55-.06-3,.42a1,1,0,0,0-.06,1.48,2.72,2.72,0,0,0,1.6.59,84.74,84.74,0,0,0,17.22.56c.75-.05,1.69-.28,1.8-1A1.15,1.15,0,0,0,241.81,465.06Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "232.003px 465.748px",
        }}
        id="elitvxqqukdcf"
        className="animable"
      />
      <g id="eltjqrhi0iw1">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "337.775px 436.511px",
          }}
          className="animable"
          id="eluk47pli8tgd"
        >
          <path
            d="M361,428.29a25.94,25.94,0,0,0-11.79-6.91c-6.65-1.58-13.6.45-19.93,3-3.89,1.6-7.84,3.52-10.44,6.83l-13,17.48c2.85,3,7.34,4,11.39,3.29a21.11,21.11,0,0,0,10.66-5.86,62.84,62.84,0,0,0,7.72-9.62,13.63,13.63,0,0,0,11.24-3.26A20.76,20.76,0,0,0,369.71,439,78.28,78.28,0,0,0,361,428.29Z"
            id="elmzdakvzyzx"
            className="animable"
            style={{
              transformOrigin: "337.775px 436.511px",
            }}
          />
        </g>
      </g>
      <path
        d="M337.17,423.62c-.74-13.74-3.47-27.06-12.44-37.48-4.48-5.21-11-10-17.67-8.45-5.3,1.21-9.06,6.22-10.41,11.49a39,39,0,0,0-.81,15.1c.58,5.09,5.23,11.31,5.81,16.39.56,4.85-2.26,9.69-1.7,14.54.52,4.56,1.3,9.62,4.89,12.48,3.77,3,9.31,2.44,13.8.65A32,32,0,0,0,338,424.25Z"
        style={{
          fill: "#213E60",
          transformOrigin: "316.725px 413.603px",
        }}
        id="elv2gtfidaqv8"
        className="animable"
      />
      <path
        d="M345.34,420.93C344,407.25,344.67,393.66,352,382c3.64-5.83,9.33-11.53,16.19-11a14.23,14.23,0,0,1,12,9.79c3.77,12.17-1.24,22.75-.91,28.18.42,7,4.24,7.82,4.62,17.81.18,4.59.17,9.7-2.94,13.08-3.28,3.55-8.84,3.82-13.54,2.73a32,32,0,0,1-22.78-20.88Z"
        style={{
          fill: "#213E60",
          transformOrigin: "364.301px 407.061px",
        }}
        id="eln9xvm1vsue"
        className="animable"
      />
      <g id="el2tvksvq3kj4">
        <path
          d="M337.17,423.62c-.74-13.74-3.47-27.06-12.44-37.48-4.48-5.21-11-10-17.67-8.45-5.3,1.21-9.06,6.22-10.41,11.49a39,39,0,0,0-.81,15.1c.58,5.09,5.23,11.31,5.81,16.39.56,4.85-2.26,9.69-1.7,14.54.52,4.56,1.3,9.62,4.89,12.48,3.77,3,9.31,2.44,13.8.65A32,32,0,0,0,338,424.25Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.4,
            transformOrigin: "316.725px 413.603px",
          }}
          className="animable"
          id="elgdcnxz0gtk"
        />
      </g>
      <g id="elxpl9m38h4k">
        <path
          d="M345.34,420.93C344,407.25,344.67,393.66,352,382c3.64-5.83,9.33-11.53,16.19-11a14.23,14.23,0,0,1,12,9.79c3.77,12.17-1.24,22.75-.91,28.18.42,7,4.24,7.82,4.62,17.81.18,4.59.17,9.7-2.94,13.08-3.28,3.55-8.84,3.82-13.54,2.73a32,32,0,0,1-22.78-20.88Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.4,
            transformOrigin: "364.301px 407.061px",
          }}
          className="animable"
          id="elrm3yefqyj4"
        />
      </g>
      <g id="ely0smixk4v3">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "329.075px 419.175px",
          }}
          className="animable"
          id="ela3epzylo0df"
        >
          <path
            d="M334.09,407.69l.46-1.66A11,11,0,0,0,328,414a10.91,10.91,0,0,0-6.52-.14,59.26,59.26,0,0,1,5.94,2c.66.27,1.41.67,1.5,1.38a2,2,0,0,1-.46,1.29l-5.5,8.56,6.3-3.83a11,11,0,0,0,7.41,9.06A82.28,82.28,0,0,1,334.09,407.69Z"
            id="elak297qnehp"
            className="animable"
            style={{
              transformOrigin: "329.075px 419.175px",
            }}
          />
        </g>
      </g>
      <g id="eluoudggaq2l">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "355.77px 416.125px",
          }}
          className="animable"
          id="eloaxqk2ewjp"
        >
          <path
            d="M362.93,415.86l-11.36-.38a51.28,51.28,0,0,1,11.48-13.54,23.74,23.74,0,0,0-13.13,11.47l-1-.5q-.21,8.7-.43,17.4a9.65,9.65,0,0,0,2.71-8l6,4c0-1.76-1.72-2.95-3.17-3.95s-3-2.55-2.5-4.23Z"
            id="elq9azevpp6jj"
            className="animable"
            style={{
              transformOrigin: "355.77px 416.125px",
            }}
          />
        </g>
      </g>
      <path
        d="M350.09,412.49c-2.08-4.38-7.2-8.69-11.88-7.41-4.66.7-7.3,4.32-8.07,9s.88,11.93,4,15.49c2.52,2.89,6.64,4.87,10.21,3.48,2.7-1,4.41-3.72,5.49-6.41C351.65,422.12,352.17,416.87,350.09,412.49Z"
        style={{
          fill: "#213E60",
          transformOrigin: "340.695px 419.178px",
        }}
        id="el5j9pxngp2ed"
        className="animable"
      />
      <g id="el33eyd9e38s9">
        <path
          d="M350.09,412.49c-2.08-4.38-7.2-8.69-11.88-7.41-4.66.7-7.3,4.32-8.07,9s.88,11.93,4,15.49c2.52,2.89,6.64,4.87,10.21,3.48,2.7-1,4.41-3.72,5.49-6.41C351.65,422.12,352.17,416.87,350.09,412.49Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.4,
            transformOrigin: "340.695px 419.178px",
          }}
          className="animable"
          id="elbc6zm5vankg"
        />
      </g>
      <path
        d="M347.8,430.3a2.94,2.94,0,0,1,.33-.6c.23-.39.57-.95.95-1.71a18.63,18.63,0,0,0,2-6.81,18.12,18.12,0,0,0-.1-4.91,15.28,15.28,0,0,0-2-5.23,16.11,16.11,0,0,0-1.82-2.44,7.84,7.84,0,0,0-2.43-2,12.45,12.45,0,0,0-3.07-1.1,8.39,8.39,0,0,0-3.31-.17,9.78,9.78,0,0,0-5.68,3.12,10.36,10.36,0,0,0-2.61,5.49,19.36,19.36,0,0,0,1.15,10.38,16.86,16.86,0,0,0,3.76,6c1.19,1.21,2,1.78,1.92,1.82a3.64,3.64,0,0,1-.57-.39,18.79,18.79,0,0,1-1.49-1.28,16.35,16.35,0,0,1-4-6,19.49,19.49,0,0,1-1.29-10.59,11,11,0,0,1,2.71-5.76,10.31,10.31,0,0,1,6-3.29,8.79,8.79,0,0,1,3.51.19A12.52,12.52,0,0,1,345,406.2a8.4,8.4,0,0,1,2.56,2.07,17.58,17.58,0,0,1,1.86,2.52,15.36,15.36,0,0,1,2,5.41,17.64,17.64,0,0,1,0,5,18.09,18.09,0,0,1-2.21,6.87,17.14,17.14,0,0,1-1,1.67A4,4,0,0,1,347.8,430.3Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "340.451px 418.437px",
        }}
        id="elxfmdxv1hvee"
        className="animable"
      />
      <path
        d="M347.13,408.94c.07.06-.87,1.19-2.2,3.15a52.49,52.49,0,0,0-7.44,16.8c-.56,2.3-.76,3.76-.85,3.75a3.59,3.59,0,0,1,.05-1,26.52,26.52,0,0,1,.44-2.79,44.5,44.5,0,0,1,7.5-16.93,26.39,26.39,0,0,1,1.76-2.2A4,4,0,0,1,347.13,408.94Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "341.88px 420.79px",
        }}
        id="el3hw6llws8gi"
        className="animable"
      />
      <path
        d="M300.3,439.13a3.43,3.43,0,0,1-.42-1,10.67,10.67,0,0,1-.43-2.94,21.33,21.33,0,0,1,.44-4.38c.31-1.62.77-3.37,1.08-5.22a17.89,17.89,0,0,0-.84-9.42,38.29,38.29,0,0,0-1.72-3.61,3.39,3.39,0,0,1,.67.85,15,15,0,0,1,1.39,2.62,17.25,17.25,0,0,1,1,9.65c-.32,1.88-.79,3.63-1.11,5.23a22.8,22.8,0,0,0-.55,4.28A17.08,17.08,0,0,0,300.3,439.13Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "300.082px 425.845px",
        }}
        id="el9ux7jg0h91d"
        className="animable"
      />
      <path
        d="M329.51,417.2a61.87,61.87,0,0,0-5.56-2.72c-3.2-1.21-6-1.45-6-1.62a14.65,14.65,0,0,1,6.16,1.14A14.46,14.46,0,0,1,329.51,417.2Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "323.73px 415.026px",
        }}
        id="elqpofov3z9nh"
        className="animable"
      />
      <path
        d="M330.29,421.88c.07.14-2.23,1.45-4.74,3.5s-4.26,4-4.38,3.92a17.1,17.1,0,0,1,4.06-4.33A16.65,16.65,0,0,1,330.29,421.88Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "325.731px 425.591px",
        }}
        id="elj3j3ohagsum"
        className="animable"
      />
      <path
        d="M366.74,401.49A29.06,29.06,0,0,1,364,403a41,41,0,0,0-11.58,9.21c-1.26,1.43-2,2.37-2,2.33a2.66,2.66,0,0,1,.41-.73,21.74,21.74,0,0,1,1.35-1.84,33.64,33.64,0,0,1,5.33-5.29,34.52,34.52,0,0,1,6.36-4c.87-.41,1.58-.72,2.09-.9S366.73,401.45,366.74,401.49Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "358.58px 408.012px",
        }}
        id="el62gnjo41c0m"
        className="animable"
      />
      <path
        d="M365.57,416a68.89,68.89,0,0,1-7.31.72,68.46,68.46,0,0,1-7.32.46,8.75,8.75,0,0,1,2.12-.42c1.31-.19,3.14-.39,5.16-.56s3.86-.25,5.19-.27A8.67,8.67,0,0,1,365.57,416Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "358.255px 416.536px",
        }}
        id="elifdmx0gm7c"
        className="animable"
      />
      <path
        d="M358.79,428a22.88,22.88,0,0,1-3.82-3,22.48,22.48,0,0,1-3.48-3.37,22.88,22.88,0,0,1,3.82,3A22,22,0,0,1,358.79,428Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "355.14px 424.815px",
        }}
        id="elflwkph2vn5"
        className="animable"
      />
      <g id="el70o1wjsgzpv">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "148.91px 326.24px",
          }}
          className="animable"
          id="elctlj27zd0f"
        >
          <path
            d="M148.91,323.43a2.81,2.81,0,1,0,2.81,2.81A2.81,2.81,0,0,0,148.91,323.43Z"
            id="el6kbfpykehui"
            className="animable"
            style={{
              transformOrigin: "148.91px 326.24px",
            }}
          />
        </g>
      </g>
      <path
        d="M151.9,324.69a3.18,3.18,0,1,1-3.17-3.17A3.17,3.17,0,0,1,151.9,324.69Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "148.72px 324.7px",
        }}
        id="ell3hoodmkoel"
        className="animable"
      />
      <path
        d="M147,326.66c-.17.12-.56,0-.89-.55a2.86,2.86,0,0,1,1.46-4.07c.6-.2,1-.06,1,.14.09.41-.87,1-1.23,2.09S147.35,326.4,147,326.66Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "147.159px 324.323px",
        }}
        id="el0qnfpdjpn0c"
        className="animable"
      />
      <g id="elf8ucuxfub2f">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "197.2px 333.22px",
          }}
          className="animable"
          id="elrui1qtuxb5g"
        >
          <path
            d="M197.21,330.4a2.82,2.82,0,1,0,2.81,2.82A2.81,2.81,0,0,0,197.21,330.4Z"
            id="elqujvlyot5"
            className="animable"
            style={{
              transformOrigin: "197.2px 333.22px",
            }}
          />
        </g>
      </g>
      <path
        d="M200.2,331.67a3.17,3.17,0,1,1-3.17-3.18A3.17,3.17,0,0,1,200.2,331.67Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "197.03px 331.66px",
        }}
        id="el0u16l0yay74"
        className="animable"
      />
      <path
        d="M195.32,333.64c-.16.12-.55,0-.89-.56A2.85,2.85,0,0,1,195.9,329c.59-.19,1-.06,1,.14.09.42-.87,1-1.23,2.09S195.65,333.37,195.32,333.64Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "195.48px 331.295px",
        }}
        id="el13j1bsx7968a"
        className="animable"
      />
      <g id="elg05vonlwzpl">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "245.75px 336.56px",
          }}
          className="animable"
          id="elj1sc96u4b29"
        >
          <path
            d="M245.75,333.75a2.81,2.81,0,1,0,2.81,2.81A2.81,2.81,0,0,0,245.75,333.75Z"
            id="eldo222ld5qwt"
            className="animable"
            style={{
              transformOrigin: "245.75px 336.56px",
            }}
          />
        </g>
      </g>
      <path
        d="M248.74,335a3.18,3.18,0,1,1-3.17-3.17A3.17,3.17,0,0,1,248.74,335Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "245.56px 335.01px",
        }}
        id="el2dnae4somto"
        className="animable"
      />
      <path
        d="M243.86,337c-.17.13-.56,0-.89-.55a2.78,2.78,0,0,1-.2-2.37,2.81,2.81,0,0,1,1.67-1.7c.59-.19,1-.06,1,.14.09.41-.87,1-1.23,2.09S244.19,336.72,243.86,337Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "244.02px 334.667px",
        }}
        id="el333qojvyddf"
        className="animable"
      />
      <g id="ely27brpfh6x9">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "288.91px 335.07px",
          }}
          className="animable"
          id="el5c0rd09sd1j"
        >
          <path
            d="M288.91,332.26a2.81,2.81,0,1,0,2.81,2.81A2.81,2.81,0,0,0,288.91,332.26Z"
            id="elt1asrzcmwlg"
            className="animable"
            style={{
              transformOrigin: "288.91px 335.07px",
            }}
          />
        </g>
      </g>
      <path
        d="M291.9,333.52a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,291.9,333.52Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "288.73px 333.52px",
        }}
        id="elhf2pvbiulk"
        className="animable"
      />
      <path
        d="M287,335.49c-.17.13-.55,0-.89-.55a2.85,2.85,0,0,1-.2-2.37,2.79,2.79,0,0,1,1.67-1.7c.59-.19,1-.06,1,.14.09.41-.87,1-1.23,2.09S287.35,335.23,287,335.49Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "287.163px 333.157px",
        }}
        id="el39an6j35pnu"
        className="animable"
      />
      <g id="elb0v4qh7pcdh">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "333.25px 330.24px",
          }}
          className="animable"
          id="el3kk6o1bx8o2"
        >
          <path
            d="M333.26,327.42a2.82,2.82,0,1,0,2.81,2.81A2.81,2.81,0,0,0,333.26,327.42Z"
            id="elqgkcrrdqzmb"
            className="animable"
            style={{
              transformOrigin: "333.25px 330.24px",
            }}
          />
        </g>
      </g>
      <path
        d="M336.25,328.69a3.17,3.17,0,1,1-3.17-3.18A3.17,3.17,0,0,1,336.25,328.69Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "333.08px 328.68px",
        }}
        id="el1nu5v0rip3a"
        className="animable"
      />
      <path
        d="M331.37,330.66c-.16.12-.55,0-.88-.56a2.77,2.77,0,0,1-.2-2.37A2.8,2.8,0,0,1,332,326c.59-.19,1-.06,1,.14.09.42-.87,1-1.22,2.09S331.7,330.39,331.37,330.66Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "331.559px 328.305px",
        }}
        id="elrrnib6nzu5p"
        className="animable"
      />
      <g id="elviqqx7f6s2">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "370px 319.36px",
          }}
          className="animable"
          id="elb0dt3etwlki"
        >
          <path
            d="M370,316.55a2.81,2.81,0,1,0,2.81,2.81A2.81,2.81,0,0,0,370,316.55Z"
            id="elohupqlf12uq"
            className="animable"
            style={{
              transformOrigin: "370px 319.36px",
            }}
          />
        </g>
      </g>
      <path
        d="M373,317.81a3.17,3.17,0,1,1-3.17-3.18A3.17,3.17,0,0,1,373,317.81Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "369.83px 317.8px",
        }}
        id="elrnp65elwuqb"
        className="animable"
      />
      <path
        d="M368.1,319.78c-.16.12-.55,0-.89-.55a2.85,2.85,0,0,1-.2-2.37,2.76,2.76,0,0,1,1.67-1.7c.59-.2,1-.07,1,.13.09.42-.87,1-1.23,2.09S368.43,319.51,368.1,319.78Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "368.263px 317.441px",
        }}
        id="elw5b5zfdzpmn"
        className="animable"
      />
      <g id="el1rwh8qcdn9p">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "130.71px 321.52px",
          }}
          className="animable"
          id="elkl3nfyai1i"
        >
          <path
            d="M130.71,317.75a3.77,3.77,0,1,0,3.77,3.77A3.77,3.77,0,0,0,130.71,317.75Z"
            id="elp7sc7jqsl6g"
            className="animable"
            style={{
              transformOrigin: "130.71px 321.52px",
            }}
          />
        </g>
      </g>
      <path
        d="M134.18,319.78a4.25,4.25,0,1,1-4.25-4.25A4.25,4.25,0,0,1,134.18,319.78Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "129.93px 319.78px",
        }}
        id="el8syu0rzdjsf"
        className="animable"
      />
      <path
        d="M127.64,322.42c-.16.12-.62-.11-1-.8a3.8,3.8,0,0,1,1.88-5.24c.74-.28,1.24-.17,1.29,0,.11.41-1.35,1.13-1.9,2.71S128,322.17,127.64,322.42Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "128.015px 319.33px",
        }}
        id="el92fvbttdpd"
        className="animable"
      />
      <g id="ele1dt5mo6p8l">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "172.45px 330.58px",
          }}
          className="animable"
          id="eln2elx6ew1y"
        >
          <path
            d="M172.45,326.81a3.77,3.77,0,1,0,3.77,3.76A3.76,3.76,0,0,0,172.45,326.81Z"
            id="elddv0uje520q"
            className="animable"
            style={{
              transformOrigin: "172.45px 330.58px",
            }}
          />
        </g>
      </g>
      <path
        d="M175.92,328.83a4.25,4.25,0,1,1-4.25-4.25A4.25,4.25,0,0,1,175.92,328.83Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "171.67px 328.83px",
        }}
        id="el6uuq8q75ga8"
        className="animable"
      />
      <path
        d="M169.38,331.47c-.16.13-.62-.11-1-.8a3.81,3.81,0,0,1,1.89-5.23c.73-.28,1.24-.17,1.28,0,.11.4-1.34,1.13-1.89,2.71S169.72,331.23,169.38,331.47Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "169.76px 328.386px",
        }}
        id="elhno9li2wsvw"
        className="animable"
      />
      <g id="elttu26ao9mr">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "222px 335.7px",
          }}
          className="animable"
          id="el5o0n1im8ioi"
        >
          <circle
            cx={222}
            cy={335.7}
            r={3.77}
            id="elxv9fp70res"
            className="animable"
            style={{
              transformOrigin: "222px 335.7px",
            }}
          />
        </g>
      </g>
      <path
        d="M225.47,334a4.25,4.25,0,1,1-4.25-4.25A4.25,4.25,0,0,1,225.47,334Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "221.22px 334px",
        }}
        id="elyqxbh8kzla8"
        className="animable"
      />
      <path
        d="M218.93,336.6c-.16.13-.62-.11-1-.8a3.8,3.8,0,0,1,1.88-5.23c.74-.29,1.24-.17,1.29,0,.11.4-1.35,1.13-1.9,2.71S219.27,336.36,218.93,336.6Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "219.308px 333.514px",
        }}
        id="elrxjms9s4wro"
        className="animable"
      />
      <g id="elr25zcsg40y">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "268.06px 336.34px",
          }}
          className="animable"
          id="elg4vkom2o63"
        >
          <circle
            cx={268.06}
            cy={336.34}
            r={3.77}
            id="elr0s9i3wy1w"
            className="animable"
            style={{
              transformOrigin: "268.06px 336.34px",
            }}
          />
        </g>
      </g>
      <path
        d="M271.53,334.6a4.25,4.25,0,1,1-4.25-4.25A4.25,4.25,0,0,1,271.53,334.6Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "267.28px 334.6px",
        }}
        id="elmm9nriymtc"
        className="animable"
      />
      <path
        d="M265,337.24c-.16.12-.62-.11-1-.8a3.81,3.81,0,0,1,1.89-5.23c.73-.29,1.24-.17,1.28,0,.11.41-1.34,1.13-1.89,2.71S265.33,337,265,337.24Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "265.38px 334.152px",
        }}
        id="el0n24l1p1k89b"
        className="animable"
      />
      <g id="eljeat5sqasse">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "310.93px 332.81px",
          }}
          className="animable"
          id="elmnoxx1zrj6"
        >
          <circle
            cx={310.93}
            cy={332.81}
            r={3.77}
            id="el8n7btz5ga2d"
            className="animable"
            style={{
              transformOrigin: "310.93px 332.81px",
            }}
          />
        </g>
      </g>
      <path
        d="M314.4,331.07a4.25,4.25,0,1,1-4.25-4.25A4.25,4.25,0,0,1,314.4,331.07Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "310.15px 331.07px",
        }}
        id="el4ij339y9eee"
        className="animable"
      />
      <path
        d="M307.86,333.71c-.16.12-.62-.11-1-.8a3.81,3.81,0,0,1,1.89-5.23c.73-.29,1.24-.17,1.28,0,.11.4-1.34,1.12-1.89,2.71S308.2,333.47,307.86,333.71Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "308.24px 330.622px",
        }}
        id="el1lksdog3u67"
        className="animable"
      />
      <g id="elqg09al5pvng">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "354px 325.77px",
          }}
          className="animable"
          id="elm4824hkcu7"
        >
          <path
            d="M354,322a3.77,3.77,0,1,0,3.77,3.77A3.76,3.76,0,0,0,354,322Z"
            id="elv5d2m0v2ddl"
            className="animable"
            style={{
              transformOrigin: "354px 325.77px",
            }}
          />
        </g>
      </g>
      <path
        d="M357.43,324a4.25,4.25,0,1,1-4.25-4.25A4.25,4.25,0,0,1,357.43,324Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "353.18px 324px",
        }}
        id="ely5xmcej8khe"
        className="animable"
      />
      <path
        d="M350.89,326.66c-.16.12-.62-.11-1-.8a3.82,3.82,0,0,1,1.88-5.23c.74-.29,1.24-.17,1.29,0,.11.41-1.34,1.13-1.89,2.71S351.23,326.41,350.89,326.66Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "351.271px 323.572px",
        }}
        id="el7vngn1kys86"
        className="animable"
      />
      <path
        d="M339.36,185.63c-4.1-5.93-44.25-13.77-86.66-13.77-31.86,0-59.41,2.47-72.66,6l-.92.23c-21.61,5.89-23.2,24.26-23.64,33.69s2.23,71.23,2.09,73.58c0,0,3.66,17.4,88,17.4,47.17,0,72.23-4.59,84.15-7.89a13.84,13.84,0,0,0,10.06-12.08c1.85-20,5.77-57.31,6.64-71C347.45,196.28,343.21,189,339.36,185.63Z"
        style={{
          fill: "#213E60",
          transformOrigin: "251.004px 237.31px",
        }}
        id="eli36ziyxd32a"
        className="animable"
      />
      <g id="elwj67esicty">
        <path
          d="M339.36,185.63c-4.1-5.93-44.25-13.77-86.66-13.77-31.86,0-59.41,2.47-72.66,6l-.92.23c-21.61,5.89-23.2,24.26-23.64,33.69s2.23,71.23,2.09,73.58c0,0,3.66,17.4,88,17.4,47.17,0,72.23-4.59,84.15-7.89a13.84,13.84,0,0,0,10.06-12.08c1.85-20,5.77-57.31,6.64-71C347.45,196.28,343.21,189,339.36,185.63Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.6,
            transformOrigin: "251.004px 237.31px",
          }}
          className="animable"
          id="elnzbi3kag2tm"
        />
      </g>
      <g id="el9nrukt7c76m">
        <g
          style={{
            opacity: 0.4,
            transformOrigin: "251.36px 190.913px",
          }}
          className="animable"
          id="el74c3pvk8d0h"
        >
          <g id="elg4pask2dh66">
            <ellipse
              cx={251.36}
              cy={187.1}
              rx={79.29}
              ry={10.63}
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.6,
                transformOrigin: "251.36px 187.1px",
              }}
              className="animable"
              id="elig6i9tvl05"
            />
          </g>
          <g id="el117lmpypszp">
            <path
              d="M265.2,204c0,.35-4.79.86-12.57,1.16s-18.56.33-30.43-.44A239.66,239.66,0,0,1,192,201c-7.66-1.5-12.28-2.92-12.21-3.25s4.83.41,12.5,1.43,18.31,2.19,30.11,2.92,22.49,1,30.25,1.2S265.18,203.59,265.2,204Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.6,
                transformOrigin: "222.495px 201.513px",
              }}
              className="animable"
              id="ele82k9wnhot"
            />
          </g>
          <g id="el3bk4n1apnp6">
            <path
              d="M285.77,203.07c0,.72-2.91,1.44-6.58,1.61s-6.68-.27-6.71-1,2.91-1.44,6.58-1.61S285.74,202.35,285.77,203.07Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.6,
                transformOrigin: "279.125px 203.375px",
              }}
              className="animable"
              id="ellf58i4zx32r"
            />
          </g>
        </g>
      </g>
      <path
        d="M272.74,252.85a22.59,22.59,0,0,1-7.61,7.54c-5,3.22-10.59,7.62-10.59,7.62s-6.83-3.66-12-6.6a22.61,22.61,0,0,1-8-7.11,16,16,0,0,1-2.26-9.81,13.12,13.12,0,0,1,3.18-7.24,12.69,12.69,0,0,1,6.49-4.25,10.21,10.21,0,0,1,11.16,4.56,10.25,10.25,0,0,1,3.16-3.78,10.37,10.37,0,0,1,7.95-1.79,12.7,12.7,0,0,1,6.71,3.88,13.12,13.12,0,0,1,3.57,7.06A16,16,0,0,1,272.74,252.85Zm33.61-7.6a7,7,0,0,0-1.55-3.92,6.83,6.83,0,0,0-3.37-2.38,5.44,5.44,0,0,0-6.16,2.41,5.4,5.4,0,0,0-5.69-3,6.75,6.75,0,0,0-3.65,1.93,7,7,0,0,0-2,3.69,8.52,8.52,0,0,0,.72,5.31,12,12,0,0,0,3.9,4.16c2.61,1.81,6.05,4.09,6.05,4.09s3.17-2.07,6-3.53a12.11,12.11,0,0,0,4.4-3.62A8.53,8.53,0,0,0,306.35,245.25Zm-81,13.74a7,7,0,0,0-2.21-3.59,6.73,6.73,0,0,0-3.73-1.76,5.56,5.56,0,0,0-4.14,1.3,5.43,5.43,0,0,0-1.51,2.15,5.43,5.43,0,0,0-1.8-1.57,5.51,5.51,0,0,0-4.32-.35,6.67,6.67,0,0,0-3.25,2.54,7,7,0,0,0-1.37,4,8.49,8.49,0,0,0,1.64,5.11,12,12,0,0,0,4.57,3.41c2.88,1.33,6.67,3,6.67,3s2.75-2.59,5.27-4.52a12.08,12.08,0,0,0,3.71-4.33A8.58,8.58,0,0,0,225.35,259Zm63.48,5.49a3.19,3.19,0,0,0-.61-1.8,3.06,3.06,0,0,0-1.47-1.14,2.48,2.48,0,0,0-1.94.16,2.45,2.45,0,0,0-.87.79,2.47,2.47,0,0,0-2.5-1.45,3,3,0,0,0-1.68.79,3.22,3.22,0,0,0-1,1.61,3.8,3.8,0,0,0,.22,2.4,5.41,5.41,0,0,0,1.66,2c1.13.86,2.63,2,2.63,2s1.47-.86,2.77-1.45a5.4,5.4,0,0,0,2-1.54A3.84,3.84,0,0,0,288.83,264.48Zm-64.34-27.66a3.08,3.08,0,0,0-.62-1.79,3,3,0,0,0-1.46-1.15,2.52,2.52,0,0,0-1.94.16,2.56,2.56,0,0,0-.88.79A2.34,2.34,0,0,0,219,234a2.49,2.49,0,0,0-1.86-.59,3.06,3.06,0,0,0-1.68.79,3.22,3.22,0,0,0-1,1.61,3.9,3.9,0,0,0,.21,2.41,5.49,5.49,0,0,0,1.67,1.95c1.13.87,2.63,2,2.63,2s1.46-.86,2.76-1.45a5.59,5.59,0,0,0,2.06-1.53A3.87,3.87,0,0,0,224.49,236.82ZM315.93,267a3.82,3.82,0,0,0-2.41-3.42,2.87,2.87,0,0,0-2.26.19,2.91,2.91,0,0,0-1,.92,2.94,2.94,0,0,0-.74-1,2.89,2.89,0,0,0-2.16-.68,3.51,3.51,0,0,0-1.95.92,3.68,3.68,0,0,0-1.16,1.88,4.52,4.52,0,0,0,.24,2.79,6.52,6.52,0,0,0,1.94,2.27c1.32,1,3.06,2.28,3.06,2.28s1.7-1,3.21-1.69a6.31,6.31,0,0,0,2.39-1.78A4.5,4.5,0,0,0,315.93,267ZM203.58,246.54a3.91,3.91,0,0,0-.63-2.3,3.79,3.79,0,0,0-1.74-1.55,3.11,3.11,0,0,0-2.45.05,3,3,0,0,0-1.16.92,3.05,3.05,0,0,0-.73-1.14,3.12,3.12,0,0,0-2.28-.88,3.8,3.8,0,0,0-2.17.86,3.94,3.94,0,0,0-1.38,1.94,4.83,4.83,0,0,0,.07,3,6.83,6.83,0,0,0,1.94,2.58c1.35,1.18,3.14,2.67,3.14,2.67s1.91-1,3.58-1.6a6.92,6.92,0,0,0,2.7-1.76A4.79,4.79,0,0,0,203.58,246.54Z"
        style={{
          fill: "#213E60",
          transformOrigin: "253.383px 252.524px",
        }}
        id="elce4rs4v71v"
        className="animable"
      />
      <g id="eluzac5ugjeop">
        <path
          d="M314.34,186.59c0,2.39-27.5,4.32-61.42,4.32s-61.43-1.93-61.43-4.32,27.5-4.31,61.43-4.31S314.34,184.21,314.34,186.59Z"
          style={{
            opacity: 0.1,
            transformOrigin: "252.915px 186.595px",
          }}
          className="animable"
          id="elwbut260lye"
        />
      </g>
      <g id="elmhphleuv8ms">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "191.4px 214.37px",
          }}
          className="animable"
          id="elqigppv7q0x"
        >
          <path
            d="M191.41,211.55a2.82,2.82,0,1,0,2.81,2.82A2.81,2.81,0,0,0,191.41,211.55Z"
            id="ela449ugg4l8g"
            className="animable"
            style={{
              transformOrigin: "191.4px 214.37px",
            }}
          />
        </g>
      </g>
      <path
        d="M194.4,212.82a3.18,3.18,0,1,1-3.17-3.18A3.17,3.17,0,0,1,194.4,212.82Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "191.22px 212.82px",
        }}
        id="elwzntof8pf9"
        className="animable"
      />
      <path
        d="M189.52,214.79c-.17.12-.56,0-.89-.55a2.86,2.86,0,0,1,1.46-4.07c.6-.2,1-.07,1,.13.09.42-.87,1-1.23,2.09S189.85,214.52,189.52,214.79Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "189.679px 212.451px",
        }}
        id="el84xmpffuakc"
        className="animable"
      />
      <g id="elh68un18memc">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "214.58px 217.91px",
          }}
          className="animable"
          id="elqgw28ve8i1i"
        >
          <path
            d="M214.58,215.1a2.81,2.81,0,1,0,2.81,2.81A2.81,2.81,0,0,0,214.58,215.1Z"
            id="elef8w0z6o3xk"
            className="animable"
            style={{
              transformOrigin: "214.58px 217.91px",
            }}
          />
        </g>
      </g>
      <path
        d="M217.57,216.36a3.18,3.18,0,1,1-3.18-3.17A3.17,3.17,0,0,1,217.57,216.36Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "214.39px 216.37px",
        }}
        id="elyph8kxwnu8"
        className="animable"
      />
      <path
        d="M212.68,218.33c-.16.12-.55,0-.88-.55a2.86,2.86,0,0,1,1.46-4.07c.59-.2,1-.06,1,.14.08.41-.88,1-1.23,2.09S213,218.07,212.68,218.33Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "212.849px 215.993px",
        }}
        id="el7z1ipjt7zjf"
        className="animable"
      />
      <g id="elein1hn1zy3r">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "238.67px 219.81px",
          }}
          className="animable"
          id="elkcxe958jk8n"
        >
          <path
            d="M238.67,217a2.81,2.81,0,1,0,2.81,2.81A2.81,2.81,0,0,0,238.67,217Z"
            id="elybwiw0juwdo"
            className="animable"
            style={{
              transformOrigin: "238.67px 219.81px",
            }}
          />
        </g>
      </g>
      <path
        d="M241.66,218.21a3.17,3.17,0,1,1-3.17-3.17A3.18,3.18,0,0,1,241.66,218.21Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "238.49px 218.21px",
        }}
        id="el1dxlpk5jjdn"
        className="animable"
      />
      <path
        d="M236.78,220.18c-.16.13-.55,0-.88-.55a2.86,2.86,0,0,1,1.46-4.07c.59-.19,1-.06,1,.14.09.41-.87,1-1.22,2.09S237.11,219.92,236.78,220.18Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "236.949px 217.847px",
        }}
        id="el3acu6scb4ya"
        className="animable"
      />
      <g id="elylmkr0f3bmh">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "308.04px 215.4px",
          }}
          className="animable"
          id="ele980g6kuaq"
        >
          <path
            d="M308.05,212.58a2.82,2.82,0,1,0,2.81,2.81A2.81,2.81,0,0,0,308.05,212.58Z"
            id="elcpbir9l8abm"
            className="animable"
            style={{
              transformOrigin: "308.04px 215.4px",
            }}
          />
        </g>
      </g>
      <path
        d="M311,213.85a3.18,3.18,0,1,1-3.18-3.18A3.17,3.17,0,0,1,311,213.85Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "307.82px 213.85px",
        }}
        id="elxbzg31in11"
        className="animable"
      />
      <path
        d="M306.15,215.82c-.16.12-.55,0-.88-.56a2.77,2.77,0,0,1-.2-2.37,2.83,2.83,0,0,1,1.66-1.7c.59-.19,1-.06,1,.14.08.42-.87,1-1.23,2.09S306.49,215.55,306.15,215.82Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "306.314px 213.48px",
        }}
        id="eluawzp5f3kt"
        className="animable"
      />
      <g id="el3phs5ni9rdz">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "285.77px 218.01px",
          }}
          className="animable"
          id="elj8z8n7n8ws"
        >
          <path
            d="M285.78,215.19a2.82,2.82,0,1,0,2.81,2.81A2.81,2.81,0,0,0,285.78,215.19Z"
            id="el0a6689refkkq"
            className="animable"
            style={{
              transformOrigin: "285.77px 218.01px",
            }}
          />
        </g>
      </g>
      <path
        d="M288.77,216.46a3.17,3.17,0,1,1-3.17-3.18A3.17,3.17,0,0,1,288.77,216.46Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "285.6px 216.45px",
        }}
        id="elb407rntjzzi"
        className="animable"
      />
      <path
        d="M283.89,218.43c-.16.12-.55,0-.89-.56a2.85,2.85,0,0,1-.2-2.37,2.81,2.81,0,0,1,1.67-1.7c.59-.19,1-.06,1,.14.09.42-.87,1-1.23,2.09S284.22,218.16,283.89,218.43Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "284.053px 216.09px",
        }}
        id="elwzbvonlaig"
        className="animable"
      />
      <g id="elpxybt5k7y7o">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "328.83px 211.11px",
          }}
          className="animable"
          id="elxor8blfqtj"
        >
          <path
            d="M328.83,208.3a2.81,2.81,0,1,0,2.81,2.81A2.81,2.81,0,0,0,328.83,208.3Z"
            id="ell6avtysaoor"
            className="animable"
            style={{
              transformOrigin: "328.83px 211.11px",
            }}
          />
        </g>
      </g>
      <path
        d="M331.83,209.56a3.18,3.18,0,1,1-3.18-3.17A3.18,3.18,0,0,1,331.83,209.56Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "328.65px 209.57px",
        }}
        id="el6v10b7ldbsg"
        className="animable"
      />
      <path
        d="M326.94,211.53c-.16.13-.55,0-.88-.55a2.77,2.77,0,0,1-.2-2.37,2.8,2.8,0,0,1,1.66-1.7c.59-.19,1-.06,1,.14.08.41-.88,1-1.23,2.09S327.28,211.27,326.94,211.53Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "327.104px 209.197px",
        }}
        id="elqofhicsceth"
        className="animable"
      />
      <g id="elp87ytkjg4l">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "170.16px 211.07px",
          }}
          className="animable"
          id="elz5ynm74x7p"
        >
          <path
            d="M170.16,208.26a2.81,2.81,0,1,0,2.81,2.81A2.81,2.81,0,0,0,170.16,208.26Z"
            id="els7mnj1nyu6o"
            className="animable"
            style={{
              transformOrigin: "170.16px 211.07px",
            }}
          />
        </g>
      </g>
      <path
        d="M173.15,209.52a3.17,3.17,0,1,1-3.17-3.17A3.17,3.17,0,0,1,173.15,209.52Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "169.98px 209.52px",
        }}
        id="elbmvnx4u7z2u"
        className="animable"
      />
      <path
        d="M168.27,211.49c-.16.13-.55,0-.89-.55a2.85,2.85,0,0,1-.2-2.37,2.81,2.81,0,0,1,1.67-1.7c.59-.19,1-.06,1,.14.09.41-.87,1-1.23,2.09S168.6,211.23,168.27,211.49Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "168.433px 209.157px",
        }}
        id="el5q2nka3yyyd"
        className="animable"
      />
      <g id="elv5ybbkzp8en">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "261.57px 218.64px",
          }}
          className="animable"
          id="elccrhrx2ygol"
        >
          <path
            d="M261.57,214.87a3.77,3.77,0,1,0,3.77,3.77A3.77,3.77,0,0,0,261.57,214.87Z"
            id="elssxq5ya2n3i"
            className="animable"
            style={{
              transformOrigin: "261.57px 218.64px",
            }}
          />
        </g>
      </g>
      <path
        d="M265,216.9a4.25,4.25,0,1,1-4.25-4.25A4.25,4.25,0,0,1,265,216.9Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "260.75px 216.9px",
        }}
        id="elomgpbghj6sq"
        className="animable"
      />
      <path
        d="M258.5,219.54c-.16.12-.62-.11-1-.8a3.8,3.8,0,0,1,1.88-5.24c.74-.28,1.24-.17,1.29,0,.1.41-1.35,1.13-1.9,2.71S258.84,219.29,258.5,219.54Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "258.875px 216.45px",
        }}
        id="elvnfwnn5n4x"
        className="animable"
      />
      <path
        d="M319.09,89.19c-.24-8.89-3.78-17.5-9.1-24.61s-12.31-12.74-20.63-15.32A33.86,33.86,0,0,0,250.7,63.38a33.87,33.87,0,0,0-35-19.23c-8.64,1.11-16.63,5.55-23,11.52s-11.46,14-13.23,22.65c-2.22,10.91-1.14,23.16,3.74,33.16,5.16,10.56,14.2,19.52,23.7,26.43,16,11.64,37.08,26.3,37.08,26.3s20-12.4,37.74-21.09c10.56-5.17,21-12.42,27.93-21.93C316.21,112.19,319.39,100.31,319.09,89.19Z"
        style={{
          fill: "#213E60",
          transformOrigin: "248.739px 104.041px",
        }}
        id="el5d9mzi8tdbv"
        className="animable"
      />
      <g id="elx69z56da9gc">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "192.798px 88.0308px",
          }}
          className="animable"
          id="el1kf4efzgrxvh"
        >
          <path
            d="M176.34,71.37a10.22,10.22,0,0,1,11.23,4.39,10.2,10.2,0,0,1,3.1-3.82A10.38,10.38,0,0,1,198.59,70a12.72,12.72,0,0,1,6.77,3.78,13.28,13.28,0,0,1,3.68,7,16.06,16.06,0,0,1-1.58,10,22.55,22.55,0,0,1-7.5,7.64c-5,3.3-10.47,7.78-10.47,7.78s-4.67-2.49-9.91-5.35c0,0-.83-3.76-1.2-7.34S176.34,71.37,176.34,71.37Z"
            id="elfzfbgo2v51p"
            className="animable"
            style={{
              transformOrigin: "192.798px 88.0308px",
            }}
          />
        </g>
      </g>
      <path
        d="M209,75.47a13.25,13.25,0,0,0-3.68-7,12.72,12.72,0,0,0-6.77-3.78,10.2,10.2,0,0,0-11,5.73A10.22,10.22,0,0,0,176.34,66a12.73,12.73,0,0,0-6.43,4.34,13.14,13.14,0,0,0-3.07,7.29,16.06,16.06,0,0,0,2.41,9.78,22.68,22.68,0,0,0,8.12,7c5.23,2.86,12.12,6.42,12.12,6.42S195,96.35,200,93.06a22.49,22.49,0,0,0,7.5-7.65A16,16,0,0,0,209,75.47Z"
        style={{
          fill: "#213E60",
          transformOrigin: "188.011px 82.6836px",
        }}
        id="elhh9slrjmdcj"
        className="animable"
      />
      <g id="el7c656vfcgzn">
        <g
          style={{
            opacity: 0.4,
            transformOrigin: "188.011px 82.6836px",
          }}
          className="animable"
          id="el3vhzrllhah4"
        >
          <path
            d="M209,75.47a13.25,13.25,0,0,0-3.68-7,12.72,12.72,0,0,0-6.77-3.78,10.2,10.2,0,0,0-11,5.73A10.22,10.22,0,0,0,176.34,66a12.73,12.73,0,0,0-6.43,4.34,13.14,13.14,0,0,0-3.07,7.29,16.06,16.06,0,0,0,2.41,9.78,22.68,22.68,0,0,0,8.12,7c5.23,2.86,12.12,6.42,12.12,6.42S195,96.35,200,93.06a22.49,22.49,0,0,0,7.5-7.65A16,16,0,0,0,209,75.47Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "188.011px 82.6836px",
            }}
            id="elwd0a27dmta"
            className="animable"
          />
        </g>
      </g>
      <g id="ell86tovyb1y">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "215.718px 50.5641px",
          }}
          className="animable"
          id="el52mdl1bx7gi"
        >
          <path
            d="M227.64,46.48a7.49,7.49,0,0,0-2.09-4,7.21,7.21,0,0,0-3.84-2.15,5.89,5.89,0,0,0-4.49,1.08,5.79,5.79,0,0,0-1.76,2.17,5.83,5.83,0,0,0-1.81-1.79,5.91,5.91,0,0,0-4.57-.7,7.18,7.18,0,0,0-3.64,2.46,7.46,7.46,0,0,0-1.75,4.14,9.09,9.09,0,0,0,1.37,5.55,12.92,12.92,0,0,0,4.61,4c3,1.62,6.87,3.64,6.87,3.64s3.13-2.54,6-4.41a13,13,0,0,0,4.26-4.34A9.11,9.11,0,0,0,227.64,46.48Z"
            id="el52m4ssd1jav"
            className="animable"
            style={{
              transformOrigin: "215.718px 50.5641px",
            }}
          />
        </g>
      </g>
      <path
        d="M228.21,43.22A7.84,7.84,0,0,0,226,39.05a7.54,7.54,0,0,0-4-2.25,6.23,6.23,0,0,0-4.71,1.13,6.3,6.3,0,0,0-1.85,2.28,6.07,6.07,0,0,0-6.67-2.61A7.54,7.54,0,0,0,205,40.18a7.81,7.81,0,0,0-1.83,4.34,9.49,9.49,0,0,0,1.43,5.81,13.59,13.59,0,0,0,4.83,4.16c3.11,1.7,7.2,3.82,7.2,3.82s3.28-2.67,6.23-4.63a13.47,13.47,0,0,0,4.46-4.55A9.5,9.5,0,0,0,228.21,43.22Z"
        style={{
          fill: "#213E60",
          transformOrigin: "215.744px 47.5133px",
        }}
        id="elurbqowbg8wa"
        className="animable"
      />
      <g id="elrixm4gbcd1e">
        <g
          style={{
            opacity: 0.4,
            transformOrigin: "215.744px 47.5133px",
          }}
          className="animable"
          id="elgbhfsv0ei0f"
        >
          <path
            d="M228.21,43.22A7.84,7.84,0,0,0,226,39.05a7.54,7.54,0,0,0-4-2.25,6.23,6.23,0,0,0-4.71,1.13,6.3,6.3,0,0,0-1.85,2.28,6.07,6.07,0,0,0-6.67-2.61A7.54,7.54,0,0,0,205,40.18a7.81,7.81,0,0,0-1.83,4.34,9.49,9.49,0,0,0,1.43,5.81,13.59,13.59,0,0,0,4.83,4.16c3.11,1.7,7.2,3.82,7.2,3.82s3.28-2.67,6.23-4.63a13.47,13.47,0,0,0,4.46-4.55A9.5,9.5,0,0,0,228.21,43.22Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "215.744px 47.5133px",
            }}
            id="elauwnv6fv8o"
            className="animable"
          />
        </g>
      </g>
      <g id="elwose84voc9p">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "296.153px 64.607px",
          }}
          className="animable"
          id="elbgzyoyv0n9o"
        >
          <path
            d="M308.08,60.51a7.52,7.52,0,0,0-2.09-4,7.13,7.13,0,0,0-3.84-2.14,5.82,5.82,0,0,0-6.26,3.25,5.7,5.7,0,0,0-1.8-1.79,5.87,5.87,0,0,0-4.57-.7,7.18,7.18,0,0,0-3.64,2.46,7.46,7.46,0,0,0-1.75,4.14,9.09,9.09,0,0,0,1.37,5.55,12.79,12.79,0,0,0,4.61,4c3,1.63,6.87,3.65,6.87,3.65s3.12-2.55,5.95-4.41a13,13,0,0,0,4.26-4.34A9.12,9.12,0,0,0,308.08,60.51Z"
            id="elbgs2d2c901b"
            className="animable"
            style={{
              transformOrigin: "296.153px 64.607px",
            }}
          />
        </g>
      </g>
      <path
        d="M308.65,57.25a7.84,7.84,0,0,0-2.19-4.17,7.54,7.54,0,0,0-4-2.25A6.23,6.23,0,0,0,297.73,52a6.12,6.12,0,0,0-1.85,2.28A6,6,0,0,0,294,52.36a6.17,6.17,0,0,0-4.78-.73,7.44,7.44,0,0,0-3.82,2.58,7.71,7.71,0,0,0-1.83,4.34A9.49,9.49,0,0,0,285,64.36a13.46,13.46,0,0,0,4.83,4.15c3.11,1.7,7.2,3.82,7.2,3.82s3.27-2.67,6.23-4.62a13.57,13.57,0,0,0,4.46-4.55A9.5,9.5,0,0,0,308.65,57.25Z"
        style={{
          fill: "#213E60",
          transformOrigin: "296.159px 61.5406px",
        }}
        id="eliuuhc7xseaf"
        className="animable"
      />
      <g id="el1h6uq0j0na3">
        <g
          style={{
            opacity: 0.4,
            transformOrigin: "296.159px 61.5406px",
          }}
          className="animable"
          id="elqtkibl40cki"
        >
          <path
            d="M308.65,57.25a7.84,7.84,0,0,0-2.19-4.17,7.54,7.54,0,0,0-4-2.25A6.23,6.23,0,0,0,297.73,52a6.12,6.12,0,0,0-1.85,2.28A6,6,0,0,0,294,52.36a6.17,6.17,0,0,0-4.78-.73,7.44,7.44,0,0,0-3.82,2.58,7.71,7.71,0,0,0-1.83,4.34A9.49,9.49,0,0,0,285,64.36a13.46,13.46,0,0,0,4.83,4.15c3.11,1.7,7.2,3.82,7.2,3.82s3.27-2.67,6.23-4.62a13.57,13.57,0,0,0,4.46-4.55A9.5,9.5,0,0,0,308.65,57.25Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "296.159px 61.5406px",
            }}
            id="ele13pwsg1py"
            className="animable"
          />
        </g>
      </g>
      <g id="el0vrapig7uxz">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "277.925px 119.44px",
          }}
          className="animable"
          id="eliamu12kbut"
        >
          <path
            d="M284.05,105.46a21.62,21.62,0,0,0,19.55-6.34c1.91-2,3.42-5.17,1.88-7.49a7.33,7.33,0,0,0-3.16-2.29l-27-12.93L259.51,74.9c-4.08,1.17-6.74,5.34-7.4,9.54s.27,8.46,1.2,12.61l5.61,25a29.19,29.19,0,0,1,1,7.3c-.23,7.22-5.57,13.08-8.92,19.49-1.87,3.59-1.39,8.16-.33,12.08,0,0,5.82-5.28,9.72-6.37,1.65-.46.62,10.46,1.94,9.35l26.48-22.13c3.41-2.85,7.08-6.15,7.56-10.58.46-4.28-2.29-8.3-5.58-11.08s-7.21-4.77-10.4-7.67c-1.87-1.71-3.45-4.81-1.6-6.54C280.12,104.61,282.25,105.11,284.05,105.46Z"
            id="elltcnyx4d8dr"
            className="animable"
            style={{
              transformOrigin: "277.925px 119.44px",
            }}
          />
        </g>
      </g>
      <g id="eltxml987eul">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "227.92px 112.072px",
          }}
          className="animable"
          id="elsqo6eag9fv"
        >
          <path
            d="M245.89,80.06c-1.76-3-4.72-5.6-8.22-6-3.71-.38-7.17,1.7-10.32,3.71A11.64,11.64,0,0,0,223,81.74c-1.78,3.32,0,7.36,1.78,10.68s3.6,7.34,1.87,10.69L207.38,137.8a83,83,0,0,0,17.52,12.33c7.87-12.83,13.37-26.93,18.83-41,1.82-4.7,3.67-9.45,4.41-14.44S248.42,84.42,245.89,80.06Z"
            id="elym5u3g2yeb"
            className="animable"
            style={{
              transformOrigin: "227.92px 112.072px",
            }}
          />
        </g>
      </g>
      <path
        d="M277.24,76l-3.59,3a90.15,90.15,0,0,0,6.24,21,5.5,5.5,0,0,0,2.08,2.83c1.39.77,3.13.25,4.52-.49s2.76-1.72,4.34-1.86a30.36,30.36,0,0,1,3.89.4,6.09,6.09,0,0,0,5-2.37A17.47,17.47,0,0,1,301.54,96c1.2-1.09,2.94-1.22,4.5-1.68l.11,0a5.29,5.29,0,0,0-.4-10.2Q291.32,80.66,277.24,76Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "291.75px 89.6052px",
        }}
        id="elv522oj3na9b"
        className="animable"
      />
      <path
        d="M240.15,104.93a4.09,4.09,0,0,0-.94-2.21c-.21-.23-.5-.4-.75-.25a1.11,1.11,0,0,0-.36.55,17.36,17.36,0,0,0-.71,2.18l.21,1.28a5.17,5.17,0,0,0,.59,1.89c.33.51.95.78,1.37.4a2.19,2.19,0,0,0,.52-1.27A8.22,8.22,0,0,0,240.15,104.93Z"
        style={{
          fill: "#213E60",
          transformOrigin: "238.805px 105.681px",
        }}
        id="elibungegvzvq"
        className="animable"
      />
      <path
        d="M196,120.05a6.69,6.69,0,0,1-3.27,1.08,13.39,13.39,0,0,0-3.4.66,3.44,3.44,0,0,0-2.23,2.47,3.36,3.36,0,0,0,2.27,3.33,9.82,9.82,0,0,0,4.29.37,3.49,3.49,0,0,0-.1,1.2,1.2,1.2,0,0,0,.65,1c.59.26,1.25-.18,1.72-.62a16.15,16.15,0,0,0,2.86-3.57Z"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "192.943px 125.144px",
        }}
        id="elc35kopwlzvm"
        className="animable"
      />
      <path
        d="M263.32,100.19c.27.07-.75,6.58-.75,6.58,2.42,0,6.14-.27,8.55-.43-.17-.15-.09-6.52-.09-6.52Z"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "266.845px 103.295px",
        }}
        id="elprz7xephj7q"
        className="animable"
      />
      <path
        d="M248.44,182.24s2.12-44.64,23.48-57.09l7.76-5.55s16.94-1.73,34.24,20.11,16.76,35.63,16.76,35.63-5.47,5.56-11.29,5.18l-4.06-1s-5.82,8.24-18.88,4.21c0,0-12.71,12.46-23.65,2.11C272.8,185.88,256.39,191.63,248.44,182.24Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "289.561px 154.759px",
        }}
        id="ellmji42hbb8"
        className="animable"
      />
      <path
        d="M262.3,104.13c-.13.53-3.4,9.28-1.41,12.86S272,127,272,127l11.39-7.39s-7.65-6.33-8.45-9.78a60,60,0,0,0-2.12-6.89Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "271.82px 114.97px",
        }}
        id="elw9l0h92t5y"
        className="animable"
      />
      <path
        d="M272.83,102.93s-4.15.53-2.29,5.12,29.93,17.75,29.93,17.75l3.15-5.59S276.26,101.1,272.83,102.93Z"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "286.84px 114.303px",
        }}
        id="el3uwxxqlz1j2"
        className="animable"
      />
      <path
        d="M300.36,125.92a16.1,16.1,0,0,0,2.85,3.57c.48.44,1.13.88,1.73.62a1.2,1.2,0,0,0,.65-1,3.49,3.49,0,0,0-.1-1.2,9.83,9.83,0,0,0,4.29-.37,3.35,3.35,0,0,0,2.26-3.33,3.44,3.44,0,0,0-2.22-2.47,13.55,13.55,0,0,0-3.41-.66,6.62,6.62,0,0,1-3.26-1.08"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "306.202px 125.094px",
        }}
        id="elxk52l4jx9ar"
        className="animable"
      />
      <path
        d="M279.49,84.08A10.18,10.18,0,0,0,277,76.42a12,12,0,0,0-6.71-3.16,15.66,15.66,0,0,0-7.4.27,11.78,11.78,0,0,0-6,5.1A27.81,27.81,0,0,0,254.09,86c-.81,2.94-1.5,6.11-.43,9a9.69,9.69,0,0,0,4.86,5.11,16.2,16.2,0,0,0,7.11,1.54,13.35,13.35,0,0,0,6.91-1.54,11.93,11.93,0,0,0,4.74-5.77A34.24,34.24,0,0,0,279.16,87"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "266.323px 87.3035px",
        }}
        id="eln1ic6nchhar"
        className="animable"
      />
      <path
        d="M255.2,85.62a5.33,5.33,0,0,0-1.63-1.32,1.53,1.53,0,0,0-1.47-.13,1.11,1.11,0,0,0-.48.93,2.27,2.27,0,0,0,.27,1,19.51,19.51,0,0,0,2.1,2.78"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "253.41px 86.4601px",
        }}
        id="elos05v6n5bn"
        className="animable"
      />
      <path
        d="M262.29,83.9a1.55,1.55,0,0,1-1.2,0,5.58,5.58,0,0,1-1.3-.6,5.51,5.51,0,0,1-1.15-.87,1.56,1.56,0,0,1-.55-1.06c0-.38.33-.74.93-.89a3.23,3.23,0,0,1,3.62,2.17A1,1,0,0,1,262.29,83.9Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "260.411px 82.2266px",
        }}
        id="elj112udrd5sr"
        className="animable"
      />
      <path
        d="M262,90a2,2,0,1,1-2-1.7A1.85,1.85,0,0,1,262,90Z"
        style={{
          fill: "#213E60",
          transformOrigin: "260.023px 90.2967px",
        }}
        id="eln9tjzb6swlo"
        className="animable"
      />
      <path
        d="M256.14,90.63c.06,0,0,.25-.23.5a1.78,1.78,0,0,1-1.23.52,1.73,1.73,0,0,1-1.25-.46c-.25-.24-.32-.45-.26-.49s.66.46,1.5.43S256,90.54,256.14,90.63Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "254.656px 91.1359px",
        }}
        id="elooy845at93"
        className="animable"
      />
      <path
        d="M260.74,74.3c-.1,1.24.39,3.21,1.44,3.88a2.81,2.81,0,0,1,1,.74,2.9,2.9,0,0,1,.23,1.32,3.29,3.29,0,0,0,2.81,2.92c-.77,1.72-1.55,3.65-.92,5.43a5,5,0,0,0,2.58,2.65,14.6,14.6,0,0,0,3.63,1.07,17,17,0,0,0,3.33.46A5.91,5.91,0,0,0,278,92c1.3-.81,1.47-.83,2-2.27,1.44-3.87,1.32-9.07-1.15-12.37a13.29,13.29,0,0,0-7.72-4.75c-2.92-.6-8.8-.64-10.41,1.71"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "270.825px 82.5194px",
        }}
        id="elkfdmufvajd"
        className="animable"
      />
      <path
        d="M272.45,91.49a8.68,8.68,0,0,0-.71,8.88,9.93,9.93,0,0,0,6.34-4.84,21.42,21.42,0,0,0,2.48-7.79Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "275.701px 94.055px",
        }}
        id="elvo1qtdqjp8a"
        className="animable"
      />
      <path
        d="M271.48,85.14a3.57,3.57,0,0,0-4.13.37,6.34,6.34,0,0,0-2,3.84l.21,3.56a3.46,3.46,0,0,0,3.27,1.57,4.5,4.5,0,0,0,3.15-2A6.6,6.6,0,0,0,273,88.91,4.36,4.36,0,0,0,271.48,85.14Z"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "269.186px 89.5742px",
        }}
        id="elwez8q2k2dol"
        className="animable"
      />
      <path
        d="M267.74,91.49a2.69,2.69,0,0,0,1.32-.07,1.26,1.26,0,0,0,.79-1,1.15,1.15,0,0,0-2-1l-.65.82.22-1a3.36,3.36,0,0,1,1.23-2c.47-.34.8-.41.82-.37s-.25.22-.62.59a3.52,3.52,0,0,0-.95,1.83l-.43-.2a1.62,1.62,0,0,1,2.82,1.42,1.69,1.69,0,0,1-2.25,1.22C267.82,91.63,267.72,91.52,267.74,91.49Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "268.768px 89.3498px",
        }}
        id="elixniw5fmiqc"
        className="animable"
      />
      <path
        d="M280.29,88.06a4.63,4.63,0,0,1,8.62-3,6.69,6.69,0,0,1,.55,4.19,11.5,11.5,0,0,1-3.55,6.63,5.23,5.23,0,0,1-2.58,1.41,6.75,6.75,0,0,1-3.71-.91,10.19,10.19,0,0,1-2.08-1.19,3.27,3.27,0,0,1-1.23-2"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "282.946px 89.9827px",
        }}
        id="elql5f2eprts"
        className="animable"
      />
      <path
        d="M262.65,85.8s-.21.35-.7.76a3.73,3.73,0,0,1-2.35.94,2.48,2.48,0,0,1-1.39-.45,3.22,3.22,0,0,1-.79-.84c-.35-.55-.44-.94-.38-1s.28.29.67.74a2.59,2.59,0,0,0,1.9,1,4.24,4.24,0,0,0,2.13-.72C262.26,85.94,262.6,85.74,262.65,85.8Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "259.836px 86.3517px",
        }}
        id="elmrvgjxakgz"
        className="animable"
      />
      <path
        d="M262.51,87.43c-.11.09-.36,0-.55-.26s-.25-.49-.14-.58.35,0,.54.25S262.62,87.34,262.51,87.43Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "262.164px 87.0099px",
        }}
        id="elqpl0i032v7"
        className="animable"
      />
      <path
        d="M235.78,100.19c-.27.07.76,6.58.76,6.58-2.42,0-6.14-.27-8.56-.43.18-.15.1-6.52.1-6.52Z"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "232.26px 103.295px",
        }}
        id="elj89deuzzxvq"
        className="animable"
      />
      <path
        d="M236.54,104.66c.13.53.05,8.3-1.94,11.88s-13.68,26.64-13.68,26.64l-5.21-23.58s7.65-6.33,8.45-9.78a57.81,57.81,0,0,1,2.12-6.89l7.52-.93Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "226.145px 122.59px",
        }}
        id="ellt1w9pxo4ef"
        className="animable"
      />
      <path
        d="M226.28,102.93s4.14.53,2.28,5.12S199,127,199,127l-3.89-7S222.85,101.1,226.28,102.93Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "212.075px 114.903px",
        }}
        id="eldjv60n2vlpr"
        className="animable"
      />
      <path
        d="M219.61,84.08a10.23,10.23,0,0,1,2.46-7.66,12,12,0,0,1,6.71-3.16,15.67,15.67,0,0,1,7.4.27,11.72,11.72,0,0,1,6,5.1A28.19,28.19,0,0,1,245,86c.81,2.94,1.5,6.11.43,9a9.69,9.69,0,0,1-4.86,5.11c-2.18,1.09-4.59.84-7,.87s-4.13.67-6.18-.53a14.5,14.5,0,0,1-5.54-6.11A33.65,33.65,0,0,1,220,87"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "232.772px 87.0592px",
        }}
        id="elpaaj99e4cb"
        className="animable"
      />
      <path
        d="M243.91,85.62a5.21,5.21,0,0,1,1.63-1.32,1.51,1.51,0,0,1,1.46-.13,1.12,1.12,0,0,1,.49.93,2.27,2.27,0,0,1-.27,1,18.87,18.87,0,0,1-2.11,2.78"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "245.7px 86.46px",
        }}
        id="eltct0d5xue9"
        className="animable"
      />
      <path
        d="M236.81,83.9a1.55,1.55,0,0,0,1.2,0,5.64,5.64,0,0,0,1.31-.6,5.71,5.71,0,0,0,1.14-.87,1.57,1.57,0,0,0,.56-1.06c0-.38-.33-.74-.93-.89a3.05,3.05,0,0,0-2.21.41,3,3,0,0,0-1.41,1.76A1,1,0,0,0,236.81,83.9Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "238.698px 82.2218px",
        }}
        id="elbezkb2cgm3t"
        className="animable"
      />
      <ellipse
        cx={239.05}
        cy={90.01}
        rx={1.97}
        ry={1.7}
        style={{
          fill: "#213E60",
          transformOrigin: "239.05px 90.01px",
        }}
        id="eltnirsu5g7xi"
        className="animable"
      />
      <path
        d="M243,90.63c.11-.09.63.48,1.47.5s1.39-.52,1.5-.43,0,.25-.26.49a1.81,1.81,0,0,1-2.48-.06C243,90.88,242.91,90.66,243,90.63Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "244.489px 91.1363px",
        }}
        id="elba12vcu1u1k"
        className="animable"
      />
      <path
        d="M238.36,74.3c.11,1.24-.38,3.21-1.43,3.88a2.63,2.63,0,0,0-1,.74c-.24.38-4,.33-4.07.78-.12,1.46.36,2,1,3.46.77,1.72,1.56,3.65.92,5.43a5,5,0,0,1-2.57,2.65,14.72,14.72,0,0,1-3.63,1.07,17.11,17.11,0,0,1-3.33.46,5.91,5.91,0,0,1-3.22-.79c-1.31-.81-1.47-.83-2-2.27-1.43-3.87-1.32-9.07,1.16-12.37A13.29,13.29,0,0,1,228,72.59c2.92-.6,8.8-.64,10.4,1.71"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "228.252px 82.5099px",
        }}
        id="elmfexfzk37j"
        className="animable"
      />
      <path
        d="M229.48,92.77c-.49,2.51-.69,4.82-2.11,7.6-2.69-.53-5.92-5.89-7.32-8.24s-1.1-3.82-1.51-4.39Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "224.01px 94.055px",
        }}
        id="ely1pkawxhxnd"
        className="animable"
      />
      <path
        d="M227.63,85.14a3.56,3.56,0,0,1,4.12.37,6.35,6.35,0,0,1,2.05,3.84l-.21,3.56a3.46,3.46,0,0,1-3.27,1.57,4.52,4.52,0,0,1-3.16-2,6.59,6.59,0,0,1-1.08-3.61A4.3,4.3,0,0,1,227.63,85.14Z"
        style={{
          fill: "rgb(255, 191, 157)",
          transformOrigin: "229.93px 89.5748px",
        }}
        id="elbih73n9kili"
        className="animable"
      />
      <path
        d="M231.37,91.49s-.09.14-.33.24a1.68,1.68,0,1,1,.57-2.64l-.43.2a3.52,3.52,0,0,0-1-1.83c-.37-.37-.65-.53-.62-.59s.35,0,.81.37a3.37,3.37,0,0,1,1.24,2l.21,1-.64-.82a1.15,1.15,0,0,0-2,1,1.26,1.26,0,0,0,.79,1A2.7,2.7,0,0,0,231.37,91.49Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "230.244px 89.3644px",
        }}
        id="elo4altf9s298"
        className="animable"
      />
      <path
        d="M236.46,85.8c0-.06.38.14.91.46a4.21,4.21,0,0,0,2.13.72,2.55,2.55,0,0,0,1.89-1c.4-.45.61-.78.68-.74s0,.42-.38,1a3.11,3.11,0,0,1-.8.84,2.43,2.43,0,0,1-1.39.45,3.73,3.73,0,0,1-2.34-.94C236.67,86.15,236.42,85.85,236.46,85.8Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "239.275px 86.3834px",
        }}
        id="el5u5ocx8n5wy"
        className="animable"
      />
      <path
        d="M240.79,70.71a3.88,3.88,0,0,0-3.07-2.59,3.2,3.2,0,0,0-3.36,2,2.51,2.51,0,0,0-3.08-.73,3.16,3.16,0,0,0-1.68,2.81A4.37,4.37,0,0,0,231,75.29l5.09,3.63c3.64-1.59,4-2.76,4.72-4A5.23,5.23,0,0,0,240.79,70.71Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "235.421px 73.5084px",
        }}
        id="elbibezg1d0bb"
        className="animable"
      />
      <path
        d="M202.66,127.11s-3.84,5.37-8,12.23c-5,8.3-15.78,20.23-15.78,20.23l4,4.89s6.25-6.15,9.88-10.26l4.73-5.36L188,165.67l5.73,3.19,14.08-25.68,12.68,2L232,121.57,233.8,102l-6.43-1.63-2,2.56Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "206.34px 134.615px",
        }}
        id="el3vvs5cudyrg"
        className="animable"
      />
      <path
        d="M201.55,142c-.23,1.56,1.55,42.47,1.55,42.47h11.34L218.89,142Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "210.21px 163.235px",
        }}
        id="eleahdgypfda"
        className="animable"
      />
      <path
        d="M233,110.36c0,.15,2,5.35,2,5.35l-3,5.86Z"
        style={{
          fill: "#213E60",
          transformOrigin: "233.5px 115.965px",
        }}
        id="el45b1ium49um"
        className="animable"
      />
      <path
        d="M236.55,103.08a1.43,1.43,0,0,0-.87-.62,1.23,1.23,0,0,0-1.05.41,2.14,2.14,0,0,0-.39.95,8.89,8.89,0,0,0,.35,4.76.71.71,0,0,0,.27.39.7.7,0,0,0,.67,0,1.32,1.32,0,0,0,.42-.46,12.41,12.41,0,0,0,1.27-2.62l.05-.25A3.68,3.68,0,0,0,236.55,103.08Z"
        style={{
          fill: "#213E60",
          transformOrigin: "235.676px 105.754px",
        }}
        id="eljewm77t7ll"
        className="animable"
      />
      <path
        d="M238,104.91a1.2,1.2,0,0,0-.22-.4.54.54,0,0,0-.42-.19.57.57,0,0,0-.42.29,1.6,1.6,0,0,0-.18.49l-.16,1.19a.74.74,0,0,0,.45.69.76.76,0,0,0,.81-.15,1.19,1.19,0,0,0,.29-.75A2.76,2.76,0,0,0,238,104.91Z"
        style={{
          fill: "#213E60",
          transformOrigin: "237.38px 105.678px",
        }}
        id="elice8xon86m"
        className="animable"
      />
      <path
        d="M225,102.45l5.55,2.31s-2.68,5.88-2.61,7a7.26,7.26,0,0,0,1.92,3.47s-1.6.7-1.63,1c-.13,1,3.62,5.43,3.62,5.43L233.8,102l-6.43-1.63Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "229.4px 111.015px",
        }}
        id="ela7zxric6xjp"
        className="animable"
      />
      <g id="elqhl6do3eg6j">
        <polygon
          points="206.59 122.93 221.15 114.3 202.77 126.99 206.59 122.93"
          style={{
            opacity: 0.3,
            transformOrigin: "211.96px 120.645px",
          }}
          className="animable"
          id="elfbu7gsp63if"
        />
      </g>
      <g id="el4uuzyt4b6lq">
        <polygon
          points="197.48 148.84 201.53 142.78 201.86 154.05 193.75 168.86 188.02 165.67 197.48 148.84"
          style={{
            opacity: 0.3,
            transformOrigin: "194.94px 155.82px",
          }}
          className="animable"
          id="el4lco015p7uf"
        />
      </g>
      <g id="el5hmu16l0a4t">
        <path
          d="M218.86,144.83c-.51-.08-16.09-3.26-16.09-3.26l-1.63,1.79,1.63-1,15.48,5.76Z"
          style={{
            opacity: 0.3,
            transformOrigin: "210px 144.845px",
          }}
          className="animable"
          id="eleg48ay8yn5s"
        />
      </g>
      <polygon
        points="210.66 132.66 213.26 130.38 220.24 133.38 218.34 136.17 210.66 132.66"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "215.45px 133.275px",
        }}
        id="elp00lbja9f2h"
        className="animable"
      />
      <path
        d="M199.57,120.64a1,1,0,1,1-1-1A1,1,0,0,1,199.57,120.64Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "198.57px 120.64px",
        }}
        id="el77adqljzxkn"
        className="animable"
      />
      <path
        d="M202,119.24a1,1,0,1,1-1-1A1,1,0,0,1,202,119.24Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "201px 119.24px",
        }}
        id="eluhhtb5kq0a8"
        className="animable"
      />
      <path
        d="M273,147.76a9.57,9.57,0,0,1,0,1.55c-.07,1.09-.15,2.5-.25,4.2-.21,3.55-.42,8.46-.45,13.89s.12,10.33.29,13.88c.08,1.71.15,3.12.2,4.21a8,8,0,0,1,0,1.55,9.94,9.94,0,0,1-.22-1.53c-.11-1-.24-2.43-.37-4.2-.26-3.56-.47-8.48-.44-13.92s.3-10.35.6-13.9c.15-1.78.29-3.21.42-4.2A8.3,8.3,0,0,1,273,147.76Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "272.394px 167.4px",
        }}
        id="elsqfmoxuyaka"
        className="animable"
      />
      <path
        d="M302.69,146c.13-.05,3.07,7.35,6.55,16.52s6.2,16.65,6.07,16.7-3.07-7.34-6.55-16.52S302.56,146.08,302.69,146Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "309px 162.61px",
        }}
        id="elsgkttvfd44"
        className="animable"
      />
      <path
        d="M288.56,150.21c.14,0,1.9,7.46,3.93,16.73s3.56,16.82,3.42,16.85-1.9-7.46-3.93-16.73S288.42,150.24,288.56,150.21Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "292.235px 167px",
        }}
        id="el5u1to9h83v"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default AnniversaryWebsiteSVG;
